import { AbpSessionService } from 'abp-ng2-module';
import { Component, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { VfModalShellComponent } from '@app/shared/common/components/modal-shell/vf-modal-shell.component';
import { NgForm } from '@angular/forms';
import { DataService } from '@app/shared/common/auth/data.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import {
  AddFavoriteInput, AgendaServiceProxy, AttachmentServiceProxy, CommonAttachment, CommonLookupServiceProxy, CreateFileInputDto, CreateFileTask, CreateFolderDto, CreateTaskFromAgendaInput, DriveCategoryInputDto, EntityType, FavoriteServiceProxy,
  FileParameter, GroupDto, GroupLinkDto, IndexedOrder, LinkDto,
  LinkServiceProxy, LookUpTables, OneDriveServiceProxy, OutlookServiceProxy,
  SortOrderIndexedInput, UserServiceProxy
} from '@shared/service-proxies/service-proxies';
import { cloneDeep, some, sortBy } from 'lodash';
import * as moment from 'moment';
import { DragulaService } from 'ng2-dragula';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { of, Subject, Subscription } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
const autoScroll = require('dom-autoscroller');

@Component({
  selector: 'vf-file-list',
  templateUrl: './file-list.component.html'
})
export class FileListComponent extends AppComponentBase implements OnInit, OnDestroy {
  @Output() openAddEditQuickLinkModalEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeEmit: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('addEditWeblinkModal') addEditWeblinkModal: ModalDirective;
  @ViewChild('addEditWeblinkForm') addEditWeblinkForm: NgForm;
  @ViewChild('addEditFileFolderForm') addEditFileFolderForm: NgForm;
  @ViewChild('sharePermissionModal') sharePermissionModal: ModalDirective;
  @ViewChild('deleteMultipleFilesDeletePopup') deleteMultipleFilesDeletePopup: ModalDirective;
  @ViewChild('nestedDropdown', { static: false }) nestedDropdown: BsDropdownDirective;
  @ViewChild('copyDropdown', { static: false }) copyDropdown: BsDropdownDirective;
  @ViewChild('moveDropdown', { static: false }) moveDropdown: BsDropdownDirective;
  @ViewChild('fileLoadErrorShell') fileLoadErrorShell: VfModalShellComponent;
  fileLoadError: { message: string; cancelLabel?: string; saveLabel?: string } | undefined;
  onedriveRecentData: Array<any> = new Array<any>();
  onedriveFilesData: Array<any> = new Array<any>();
  pinnedFilesData: Array<any> = new Array<any>();
  todayFiles: Array<any> = new Array<any>();
  yesterdayFiles: Array<any> = new Array<any>();
  earlyThisWeekFiles: Array<any> = new Array<any>();
  lastWeekFiles: Array<any> = new Array<any>();
  olderFiles: Array<any> = new Array<any>();
  shortcutData: Array<any> = new Array<any>();
  pinnedShortcutData: Array<any> = new Array<any>();
  teamDriveData: Array<any> = new Array<any>();
  teamDriveCategoryData: Array<any> = new Array<any>();
  fileUploadError = false;
  fileErrorMsg = '';
  fileCtrl: any;
  isLoading = false;
  isPinnedFilesLoading = false;
  isPinnedLinksLoading = false;
  clientId: any;
  uploadingItems: LinkDto[] = [];
  uploadingItems2: GroupLinkDto[] = [];
  userSectionData = [];
  fileType = '';
  isShareFile = true;
  searchText = '';
  isSearchApplied = false;
  currentTab = 1;
  noMatchingRecentSearch = false;
  delQLinkItem: any;
  delDriveCategoryItem: any;
  url = '';
  isOutlookConfig: boolean;
  isLoadingFiles = false;
  isWordChecked = false;
  isExcelChecked = false;
  isPPChecked = false;
  isPDFChecked = false;
  isHideToday = false;
  isHideYesterday = false;
  isHideEarly = false;
  isHideLastWeek = false;
  isHideOlder = false;
  isHidePinnedFiles = false;
  selectedFileType = '';
  itemId = '';
  driveId = '';
  driveType = '';
  documentName = '';
  oneDrivePath = '';
  sharePointPath = '';
  isAccLinked = true;
  noDataForTabs = false;
  isCategorySaving = false;
  isShortcutLoading = false;
  isTeamDataLoading = false;
  isLoadingTeamDrive = false;
  showBlankCategoryError = false;
  isDriveCategoryLoading = false;
  isPinnedShortcutLoading = false;
  isAddNewCategoryClicked = false;
  showDuplicateCategoryError = false;
  subs = new Subscription();
  myOneDriveLink = '';
  isUploadFiles = false;
  isSaving = false;
  loadFilesCountFrom = 1;
  private onSearching: Subject<any> = new Subject();
  isLocationError = false;
  fileRawData: Array<any> = new Array<any>();
  noDataForRecentFilesTab = false;
  groupLinkObj: GroupLinkDto = new GroupLinkDto();
  groupData: any = [];
  isSharePointSelected = false;
  isOneDriveSelected = false;
  delTeamItem: any;
  newDriveCategoryName = '';
  private categoryUpdated: Subject<any> = new Subject();
  isInvalidUrl = false;
  isSectionOpen = true;
  showFilePopup = false;
  isSingleSelectMode = false;
  isShowFolderOnly = false;
  selectedCatId = 0;
  poolItems: any = [];
  scrollElemnts: any;
  driveItems: Array<any> = new Array<any>();
  isSharePointSitesLoading = false;
  isFolderEmpty = false;
  noResultFound = false;
  delFileItem: any;
  isShowSelectAll = false;
  isAllItemsSelected = false;
  noOfSelectedItems = 0;
  isDeleting = false;
  isShowAddItem = false;
  selectedDocType = 1;
  sharePointSitesData: Array<any> = new Array<any>();
  nextBatchLink = '';
  isShowInfoPopup = false;
  information = '';
  currentTabNames = [
    { id: 0, displayName: '' },
    { id: 1, displayName: 'Team resources' },
    { id: 2, displayName: 'My files' },
    { id: 3, displayName: 'SharePoint' },
    { id: 4, displayName: 'Recent' }
  ];
  activeSubmenu: string | null = null;
  constructor(injector: Injector,
    private _agendaService: AgendaServiceProxy,
    private _linkService: LinkServiceProxy,
    private _favoriteService: FavoriteServiceProxy,
    private _attachmentService: AttachmentServiceProxy,
    private _sessionService: AbpSessionService,
    private dataService: DataService,
    private _oneDriveService: OneDriveServiceProxy,
    private dragulaService: DragulaService,
    private _userServiceProxy: UserServiceProxy,
    private _commonLookupServiceProxy: CommonLookupServiceProxy,
    private _outlook: OutlookServiceProxy) {
    super(injector);
    this.onSearching
      .pipe(debounceTime(1000))
      .subscribe((result) => {
        this.refreshTabsData();
      });
    this.categoryUpdated
      // .pipe(debounceTime(300))
      .pipe(debounceTime(1000))
      .subscribe((result) => {
        this.saveCategory(result);
      });

  }

  showSubmenu(submenuName: string) {
    this.activeSubmenu = submenuName;
  }

  hideSubmenu(submenuName: string) {
    setTimeout(() => {
      if (this.activeSubmenu === submenuName) {
        this.activeSubmenu = null;
      }
    }, 100);
  }
  ngOnInit() {
    let that = this;
    if (this.dataService.refreshFilesSlider.observers.length === 0) {
      this.subs.add(this.dataService.refreshFilesSlider.subscribe(data => {
        if (!$('.right-side-bar-files').hasClass('collapsed')) {
          this.refreshTabsData();
        }
      }));
    }

    if (this.dataService.closeFileList.observers.length === 0) {
      this.subs.add(this.dataService.closeFileList.subscribe(() => {
        if ($('.right-side-bar-files').length > 0 || !$('.right-side-bar-files').hasClass('collapsed')) {
          this.closeFiles();
        }
      }));
    }

    if (this.dataService.onChangeUserSection.observers.length === 0) {
      this.subs.add(this.dataService.onChangeUserSection.subscribe(() => {
        this.getUserSections();
      }));
    }

    if (this.dataService.refreshGroups.observers.length === 0) {
      this.dataService.refreshGroups.subscribe((data) => {
        if (this.currentTab === 1) {
          this.getTeamDriveData(false);
        }
        this.getAllGroups();
      });
    }

    this.dragulaService.createGroup('fileDragula', {
      // accepts: function (el, target, source, sibling) {
      //     return target.id === 'mineTarget';
      // },
      moves: function (el, source, handle, sibling) {
        return handle.className.includes('lni-sort');
      },
      invalid: function (el, handle) {
        return el.classList.contains('pt-5') || el.classList.contains('nv');
      }
    });
    this.subs.add(this.dragulaService.drag('fileDragula')
      .subscribe(({ name, el, source }) => {
        el.classList.add('is-moving');
        document.addEventListener('mousemove', this.onDragReposition, false);
      })
    );
    this.subs.add(this.dragulaService.cancel('fileDragula')
      .subscribe(({ name, el, source }) => {
        el.classList.remove('is-moving');
        document.removeEventListener('mousemove', this.onDragReposition, false);
        window.setTimeout(function () {
          el.classList.add('is-moved');
          window.setTimeout(function () {
            el.classList.remove('is-moved');
          }, 1000);
        }, 100);
      })
    );
    this.subs.add(this.dragulaService.drop('fileDragula')
      .subscribe(({ name, el, target, source, sibling }) => {
        el.classList.remove('is-moving');
        document.removeEventListener('mousemove', this.onDragReposition, false);
        window.setTimeout(function () {
          el.classList.add('is-moved');
          window.setTimeout(function () {
            el.classList.remove('is-moved');
          }, 1000);
        }, 100);
      })
    );
    this.subs.add(this.dragulaService.dropModel('fileDragula')
      .subscribe(({ name, el, target, source, sibling, item, sourceModel, targetModel, sourceIndex, targetIndex }) => {
        if (target.id === source.id) {
          //within same section but not Other Projects
          if (target.id === 'pinnedFiles') {
            this.sortLinks(targetModel);
          }
        }
      })
    );


    // this.dragulaService.createGroup('shortcutDragula', {
    //   // accepts: function (el, target, source, sibling) {
    //   //     return target.id === 'mineTarget';
    //   // },
    //   moves: function (el, source, handle, sibling) {
    //     return handle.className.includes('lni-sort');
    //   },
    //   invalid: function (el, handle) {
    //     return el.classList.contains('pt-5') || el.classList.contains('nv');
    //   }
    // });
    // this.subs.add(this.dragulaService.drag('shortcutDragula')
    //   .subscribe(({ name, el, source }) => {
    //     el.classList.add('is-moving');
    //     document.addEventListener('mousemove', this.onDragReposition, false);
    //   })
    // );
    // this.subs.add(this.dragulaService.cancel('shortcutDragula')
    //   .subscribe(({ name, el, source }) => {
    //     el.classList.remove('is-moving');
    //     document.removeEventListener('mousemove', this.onDragReposition, false);
    //     window.setTimeout(function () {
    //       el.classList.add('is-moved');
    //       window.setTimeout(function () {
    //         el.classList.remove('is-moved');
    //       }, 1000);
    //     }, 100);
    //   })
    // );
    // this.subs.add(this.dragulaService.drop('shortcutDragula')
    //   .subscribe(({ name, el, target, source, sibling }) => {
    //     el.classList.remove('is-moving');
    //     document.removeEventListener('mousemove', this.onDragReposition, false);
    //     window.setTimeout(function () {
    //       el.classList.add('is-moved');
    //       window.setTimeout(function () {
    //         el.classList.remove('is-moved');
    //       }, 1000);
    //     }, 100);
    //   })
    // );
    // this.subs.add(this.dragulaService.dropModel('shortcutDragula')
    //   .subscribe(({ name, el, target, source, sibling, item, sourceModel, targetModel, sourceIndex, targetIndex }) => {
    //     if (target.id === source.id) {
    //       //within same section but not Other Projects
    //       if (target.id === 'pinnedShortcut') {
    //         this.sortLinks(targetModel);
    //       }
    //     }
    //   })
    // );

    this.dragulaService.createGroup('teamDriveCatDragula', {
      moves: function (el, container, handle) {
        return handle.parentElement.classList.contains('drive-category-sort');
      },
      invalid: function (el, handle) {
        return el.classList.contains('pt-5') || el.classList.contains('nv');
      }
    });
    this.subs.add(this.dragulaService.drag('teamDriveCatDragula')
      .subscribe(({ name, el, source }) => {
        el.classList.add('is-moving');
        document.addEventListener('mousemove', this.onDragReposition, false);
      })
    );
    this.subs.add(this.dragulaService.cancel('teamDriveCatDragula')
      .subscribe(({ name, el, source }) => {
        el.classList.remove('is-moving');
        document.removeEventListener('mousemove', this.onDragReposition, false);
        window.setTimeout(function () {
          el.classList.add('is-moved');
          window.setTimeout(function () {
            el.classList.remove('is-moved');
          }, 1000);
        }, 100);
      })
    );
    this.subs.add(this.dragulaService.drop('teamDriveCatDragula')
      .subscribe(({ name, el, target, source, sibling }) => {
        el.classList.remove('is-moving');
        document.removeEventListener('mousemove', this.onDragReposition, false);
        window.setTimeout(function () {
          el.classList.add('is-moved');
          window.setTimeout(function () {
            el.classList.remove('is-moved');
          }, 1000);
        }, 100);
      })
    );
    this.subs.add(this.dragulaService.dropModel('teamDriveCatDragula')
      .subscribe(({ name, el, target, source, sibling, item, sourceModel, targetModel, sourceIndex, targetIndex }) => {
        if (target.id === source.id) {
          if (target.id === 'TeamDriveSections') {
            this.sortDriveCategories(targetModel);
          }
        }
      })
    );

    this.dragulaService.createGroup('teamDriveLinkDragula', {
      moves: function (el, container, handle) {
        return handle.parentElement.classList.contains('category-links-sort');
      },
      invalid: function (el, handle) {
        return el.classList.contains('pt-5') || el.classList.contains('nv');
      }
    });
    this.subs.add(this.dragulaService.drag('teamDriveLinkDragula')
      .subscribe(({ name, el, source }) => {
        el.classList.add('is-moving');
        document.addEventListener('mousemove', this.onDragReposition, false);
      })
    );
    this.subs.add(this.dragulaService.cancel('teamDriveLinkDragula')
      .subscribe(({ name, el, source }) => {
        el.classList.remove('is-moving');
        document.removeEventListener('mousemove', this.onDragReposition, false);
        window.setTimeout(function () {
          el.classList.add('is-moved');
          window.setTimeout(function () {
            el.classList.remove('is-moved');
          }, 1000);
        }, 100);
      })
    );
    this.subs.add(this.dragulaService.drop('teamDriveLinkDragula')
      .subscribe(({ name, el, target, source, sibling }) => {
        el.classList.remove('is-moving');
        document.removeEventListener('mousemove', this.onDragReposition, false);
        window.setTimeout(function () {
          el.classList.add('is-moved');
          window.setTimeout(function () {
            el.classList.remove('is-moved');
          }, 1000);
        }, 100);
      })
    );
    this.subs.add(this.dragulaService.dropModel('teamDriveLinkDragula')
      .subscribe(({ name, el, target, source, sibling, item, sourceModel, targetModel, sourceIndex, targetIndex }) => {
        if (target.id === source.id) {
          let tmpTargetCat = this.teamDriveCategoryData.find(x => x.id === Number(target.getAttribute('data-categoryId')));
          if (tmpTargetCat) {
            tmpTargetCat.links = targetModel;
            tmpTargetCat.noOfItems = targetModel.length;
          }
          this.sortDriveLinks();
        } else {
          let tmpTargetCat = this.teamDriveCategoryData.find(x => x.id === Number(target.getAttribute('data-categoryId')));
          if (tmpTargetCat) {
            tmpTargetCat.links = targetModel;
            tmpTargetCat.noOfItems = targetModel.length;
          }
          let sourceCat = this.teamDriveCategoryData.find(x => x.id === Number(source.getAttribute('data-categoryId')));
          if (sourceCat) {
            sourceCat.links = sourceModel;
            sourceCat.noOfItems = sourceModel.length;
          }
          this.createDriveCategoriesLinks(item, target.getAttribute('data-categoryId'));
          this.sortDriveLinks();
        }
      })
    );
  }

  initializeScroll() {
    if (this.scrollElemnts) {
      this.scrollElemnts.destroy();
      this.scrollElemnts = undefined;
    }
    setTimeout(() => {
      if (!this.scrollElemnts) {
        const card: HTMLElement = document.querySelector('.teamDriveTabScroll');
        // Enable autoscrolling
        this.scrollElemnts = autoScroll([card], {
          margin: 100,
          maxSpeed: 30,
          // True, so the list keeps panning once the pointer reaches the top edge. With false,
          // dom-autoscroller drops its tracked element as soon as the pointer leaves it and its
          // scroll loop returns early, so a drag to the top froze the pan part-scrolled. Stopped on
          // mouseup by the library's own onUp.
          scrollWhenOutside: true,
          autoScroll: function () {
            // Only scroll when the pointer is down
            return this.down;
          }
        });
      }
    }, 2000);
  }

  onDragReposition(e) {
    const card: HTMLElement = document.querySelector('.is-moving.gu-mirror');
    if (!!card) {
      card.style.left = e.pageX + 'px';
      // card.style.top = e.pageY + 'px';
      card.style.transform = 'translateX(-50%)';
    }
  }

  private getApiSettings() {
    this._outlook.getApiSettingList()
      .subscribe((result) => {
        if (result.responseData) {
          result.responseData.forEach(i => {
            //microsoft 365
            if (i.integrationCode === 101) {
              this.url = i.graphApiAuthorizeUrl; //'https://login.microsoftonline.com/c9880ca6-a569-43a6-8923-507051ac7b1b/oauth2/v2.0/authorize?'
              AppConsts.O365QueryParams.clientId = i.clientId;
              AppConsts.O365QueryParams.scope = i.scope;
              AppConsts.O365QueryParams.redirectUri = i.redirectUri;
              AppConsts.O365QueryParams.state = this._sessionService.userId.toString() + ',' + this._sessionService.tenantId.toString() + ',' + i.integrationId.toString();
              this.isOutlookConfig = i.isConfigured;
              AppConsts.O365QueryParams.responseMode = i.responseMode;
              AppConsts.O365QueryParams.responseType = i.responseType;
              this.clientId = i.clientId;
            }
          });
        }
      });
  }

  private clearUploadFilesObjs() {
    this.uploadingItems = [];
    this.fileType = '';
    this.isShareFile = true;
    this.oneDrivePath = '';
    this.sharePointPath = '';
    this.driveType = '';
    this.itemId = '';
    this.driveId = '';
    if (this.isUploadFiles) {
      this.isUploadFiles = false;
    }
    this.isLocationError = false;
  }

  refreshTabsData() {
    // if (this.currentTab === 4) {
    //   this.getRecentFiles(false);
    // } else if (this.currentTab === 2) {
    //   this.getMyFiles(true);
    //   this.hideSelectAllBar();
    // } else if (this.currentTab === 1) {
    //   this.getTeamDriveData(false);
    // }
    // commented all other tabs, so loading only tab 1 data
    this.getTeamDriveData(false);
  }

  private sortDriveCategories(inputCollection: any) {
    let sortInput: SortOrderIndexedInput = new SortOrderIndexedInput();
    let idx = 1;
    sortInput.orders = [];
    inputCollection.forEach(x => {
      let tmpIndex: IndexedOrder = new IndexedOrder();
      tmpIndex.keyId = x.id;
      tmpIndex.tblId = 13;
      tmpIndex.sortOrder = idx;
      sortInput.orders.push(tmpIndex);
      idx++;
    });
    this.sortTask(sortInput);
  }

  createDriveCategoriesLinks(item, categoryId) {
    // Update drive category id
    let input: GroupLinkDto = new GroupLinkDto();
    input = item;
    input.driveCategoryId = Number(categoryId);
    this._linkService.createOrUpdateGroupLink(input).subscribe(result => { });
  }

  private sortDriveLinks() {
    // Sorting
    let sortInput: SortOrderIndexedInput = new SortOrderIndexedInput();
    let idx = 1;
    sortInput.orders = [];
    this.teamDriveCategoryData.forEach(element => {
      element.links.forEach(link => {
        let tmpIndex: IndexedOrder = new IndexedOrder();
        tmpIndex.keyId = link.id;
        tmpIndex.tblId = 14;
        tmpIndex.sortOrder = idx;
        sortInput.orders.push(tmpIndex);
        idx++;
      });
    });
    this.sortTask(sortInput);
  }

  private sortLinks(inputCollection: any) {
    let sortInput: SortOrderIndexedInput = new SortOrderIndexedInput();
    let idx = 1;
    sortInput.orders = [];
    inputCollection.forEach(x => {
      let tmpIndex: IndexedOrder = new IndexedOrder();
      tmpIndex.keyId = x.linkId ? x.linkId : x.id;
      tmpIndex.tblId = x.tblId ? x.tblId : 8;
      tmpIndex.sortOrder = idx;
      sortInput.orders.push(tmpIndex);
      idx++;
    });
    this.sortTask(sortInput);
  }

  private sortTask(sortInput: SortOrderIndexedInput): void {
    this._agendaService.createUpdateIndexedSortOrder(sortInput).subscribe(result => {
    });
  }

  private resetValues(): void {
    this.onedriveFilesData = [];
    this.onedriveRecentData = [];
    this.todayFiles = [];
    this.yesterdayFiles = [];
    this.earlyThisWeekFiles = [];
    this.lastWeekFiles = [];
    this.olderFiles = [];
    this.driveItems = [];
    this.pinnedFilesData = [];
    this.uploadingItems = [];
    this.isShareFile = true;
    this.searchText = '';
    this.isSearchApplied = false;
    this.currentTab = 1;
    this.noMatchingRecentSearch = false;
    this.isHideToday = false;
    this.isHideYesterday = false;
    this.isHideEarly = false;
    this.isHideLastWeek = false;
    this.isHideOlder = false;
    this.isHidePinnedFiles = false;
    this.isShortcutLoading = false;
  }

  private getAllGroups() {
    let filterinput_0: any = { filter: '', isEntityIdsNameRequired: false, entityIds: '', lookUpTableName: LookUpTables._0, isInActiveDataRequired: false, excludeIds: null, sorting: '', skipCount: 0, maxResultCount: 999999 };
    this._commonLookupServiceProxy.getAllForLookupTable(
      filterinput_0.sorting,
      filterinput_0.skipCount,
      filterinput_0.maxResultCount,
      filterinput_0.filter,
      filterinput_0.isEntityIdsNameRequired,
      filterinput_0.entityIds,
      filterinput_0.lookUpTableName,
      filterinput_0.isInActiveDataRequired,
      filterinput_0.excludeIds
    ).subscribe((result) => {
      this.groupData = result;
    });
  }

  private clearGroupData() {
    if (this.groupData.length > 0) {
      this.groupData.forEach(element => {
        element.isChecked = false;
      });
    }
  }

  getTeamDriveData(isReload?): void {
    this.isLoadingTeamDrive = true;
    this.isSectionOpen = true;
    if (isReload) {
      this.isDriveCategoryLoading = true;
      this.teamDriveCategoryData = [];
      this.teamDriveData = [];
      this.isTeamDataLoading = true;
    }
    this._linkService.getDriveCategories().subscribe((result) => {
      this.isDriveCategoryLoading = false;
      if (!result.isError) {
        // this.teamDriveCategoryData = cloneDeep(result.responseData);
        result.responseData.forEach(element => {
          // check if category is available in teamdrivecategorydata if not then add it
          let isExist = some(this.teamDriveCategoryData, { id: element.id });
          if (!isExist) {
            this.teamDriveCategoryData.push(element);
          }
        });
        this._linkService.getAllGroupLinks(undefined, undefined, this.searchText).subscribe((result) => {
          this.isLoadingTeamDrive = false;
          this.isTeamDataLoading = false;
          if (!result.isError) {
            // this.teamDriveData = cloneDeep(result.responseData);
            // this.teamDriveCategoryData = cloneDeep(result.responseData);
            result.responseData.forEach(element => {
              // check if category is available in teamdrivecategorydata if not then add it
              let isExist = some(this.teamDriveData, { id: element.id });
              if (!isExist) {
                this.teamDriveData.push(element);
              }
            });
            this.teamDriveCategoryData.forEach(categoryItem => {
              let tmpTeamDriveData = this.teamDriveData.filter(x => x.driveCategoryId === categoryItem.id);
              categoryItem.noOfItems = tmpTeamDriveData.length;
              categoryItem.links = tmpTeamDriveData.length > 0 ? tmpTeamDriveData : [];
              if (this.isSearchApplied && categoryItem.noOfItems === 0) {
                categoryItem.isHide = true;
              } else {
                categoryItem.isHide = false;
              }
            });
            if (this.isSearchApplied && result.responseData && result.responseData.length === 0) {
              this.noMatchingRecentSearch = true;
            }
          }
        });
      }
    });
  }

  refreshOnRename() {
    if (this.currentTab === 4) {
      this.getRecentFiles(false);
    } else if (this.currentTab === 2) {
      this.getMyFiles(true);
    } else if (this.currentTab === 1) {
      this.getTeamDriveLinks();
    }
  }

  getTeamDriveLinks(): void {
    this._linkService.getAllGroupLinks(undefined, undefined, this.searchText).subscribe((result) => {
      if (!result.isError) {
        this.teamDriveData = cloneDeep(result.responseData);
        this.teamDriveCategoryData.forEach(categoryItem => {
          let tmpTeamDriveData = this.teamDriveData.filter(x => x.driveCategoryId === categoryItem.id);
          categoryItem.noOfItems = tmpTeamDriveData.length;
          categoryItem.links = tmpTeamDriveData.length > 0 ? tmpTeamDriveData : [];
          if (this.isSearchApplied && categoryItem.noOfItems === 0) {
            categoryItem.isHide = true;
          } else {
            categoryItem.isHide = false;
          }
        });
        if (this.isSearchApplied && result.responseData && result.responseData.length === 0) {
          this.noMatchingRecentSearch = true;
        }
      }
    });
  }

  getShortcuts(): void {
    this.isShortcutLoading = true;
    this.shortcutData = [];
    this.pinnedShortcutData = [];
    this._linkService.getUserShortcuts(undefined, undefined, this.searchText, 3, false, 0)
      .subscribe((result) => {
        this.isShortcutLoading = false;
        if (result.responseData && result.responseData.length > 0) {

          this.shortcutData = result.responseData.filter(x => x.pinnedEntityId === null);
          this.shortcutData.forEach(element => {
            if (element.siteId != null) {
              element.isLocationLoading = false;
            }
          });

          this.pinnedShortcutData = result.responseData.filter(x => x.pinnedEntityId !== null);
          this.pinnedShortcutData.forEach(element => {
            if (element.siteId != null) {
              element.isLocationLoading = false;
            }
          });
          let c = sortBy(this.pinnedShortcutData, ['sortOrder']);
          this.pinnedShortcutData = c;
        } else {
          this.shortcutData = [];
          this.pinnedShortcutData = [];
        }

        if (this.isSearchApplied && result.responseData && result.responseData.length === 0) {
          this.noMatchingRecentSearch = true;
        }
      });
  }

  selectRecentFileTab(): void {
    this.loadFilesCountFrom = 1;
    this.getRecentFiles(true);
  }

  getRecentFiles(fromTab) {
    // if (this.isLoadingFiles) {
    //   return;
    // }
    this.isLoadingFiles = true;
    this.onedriveFilesData = [];
    this.onedriveRecentData = [];
    this.todayFiles = [];
    this.yesterdayFiles = [];
    this.earlyThisWeekFiles = [];
    this.lastWeekFiles = [];
    this.olderFiles = [];
    this._oneDriveService.getMyRecentFiles(this.searchText, false, this.loadFilesCountFrom).subscribe((result) => {
      if (!result.isError) {
        this.onedriveFilesData = [];
        this.onedriveRecentData = [];
        this.todayFiles = [];
        this.yesterdayFiles = [];
        this.earlyThisWeekFiles = [];
        this.lastWeekFiles = [];
        this.olderFiles = [];
        if (result.responseData && result.responseData.length > 0) {
          result.responseData.forEach(element => {
            let itm = {
              id: element.id,
              name: element.name,
              webUrl: element.webUrl,
              extension: element.extension,
              linkId: element.linkId,
              isHide: false,
              type: 1,
              lastModifiedBy: element.lastModifiedBy,
              lastModifiedDateTime: element.lastModifiedDateTime,
              driveId: element.driveId,
              siteId: element.siteId,
              driveName: element.driveName,
              siteName: element.siteName,
              isLocationLoading: false,
              folderId: element.folderId,
              isPinned: element.isPinned
            };
            this.onedriveRecentData.push(itm);
            this.onedriveFilesData = cloneDeep(this.onedriveRecentData);
            let userTimezoneOffset = this.appSession.user.userTimeZoneOffset;
            let todayAsCurrUser = moment(new Date()).utc().utcOffset(userTimezoneOffset).format('YYYY-MM-DD');
            let yesterdayAsCurrUser = moment(new Date()).utc().add(-1, 'day').utcOffset(userTimezoneOffset).format('YYYY-MM-DD');
            let earlyWeekEndAsCurrUser = moment(new Date()).utc().add(-2, 'day').utcOffset(userTimezoneOffset);
            let earlyWeekStartAsCurrUser = moment(new Date()).utc().add(-7, 'day').utcOffset(userTimezoneOffset);
            let lastWeekEndAsCurrUser = moment(new Date()).utc().add(-8, 'day').utcOffset(userTimezoneOffset);
            let lastWeekStartAsCurrUser = moment(new Date()).utc().add(-14, 'day').utcOffset(userTimezoneOffset);
            let olderStartAsCurrUser = moment(new Date()).utc().add(-15, 'day').utcOffset(userTimezoneOffset);

            if ((element.lastModifiedDateTime as any).year() < moment(new Date()).utc().utcOffset(userTimezoneOffset).year() &&
              (element.lastModifiedDateTime as any).diff(moment(new Date()).utc().utcOffset(userTimezoneOffset), 'day') < -14) {
              this.olderFiles.push(itm);
            } else {
              if (todayAsCurrUser === (element.lastModifiedDateTime as any).format('YYYY-MM-DD')) {
                this.todayFiles.push(itm);
              } else if (yesterdayAsCurrUser === (element.lastModifiedDateTime as any).format('YYYY-MM-DD')) {
                this.yesterdayFiles.push(itm);
              } else if ((element.lastModifiedDateTime as any) >= earlyWeekStartAsCurrUser &&
                (element.lastModifiedDateTime as any) <= earlyWeekEndAsCurrUser) {
                this.earlyThisWeekFiles.push(itm);
              } else if ((element.lastModifiedDateTime as any) >= lastWeekStartAsCurrUser &&
                (element.lastModifiedDateTime as any) <= lastWeekEndAsCurrUser) {
                this.lastWeekFiles.push(itm);
              } else if ((element.lastModifiedDateTime as any) < olderStartAsCurrUser) {
                this.olderFiles.push(itm);
              }
            }
          });
          if (this.searchText.trim() !== '') {
            this.applyRecentLinkSearch();
          }
          this.loadFilesCountFrom = this.onedriveRecentData.length;
        }
        if (this.isSearchApplied && (!result.responseData || (result.responseData && result.responseData.length === 0))) {
          this.noMatchingRecentSearch = true;
        }
      }
      this.isLoadingFiles = false;
      this.checkNoDataForRecentFiles();
    });
  }

  getMoreRecentFiles(event?: any) {
    if (!$('.right-side-bar-files').hasClass('collapsed') && !this.isLoadingFiles && this.currentTab === 4) {

      if (this.loadFilesCountFrom < 50 && !this.isLoadingFiles) {
        this.isLoadingFiles = true;
        this._oneDriveService.getMyRecentFiles(this.searchText, true, this.loadFilesCountFrom).subscribe((result) => {
          if (!result.isError) {
            if (result.responseData && result.responseData.length > 0) {
              result.responseData.forEach(element => {
                let itm = {
                  id: element.id,
                  name: element.name,
                  webUrl: element.webUrl,
                  extension: element.extension,
                  linkId: element.linkId,
                  isHide: false,
                  type: 1,
                  lastModifiedBy: element.lastModifiedBy,
                  lastModifiedDateTime: element.lastModifiedDateTime,
                  driveId: element.driveId,
                  siteId: element.siteId,
                  driveName: element.driveName,
                  siteName: element.siteName,
                  isLocationLoading: false,
                  folderId: element.folderId,
                  isPinned: element.isPinned
                };
                if (this.onedriveRecentData.findIndex(x => x.id === itm.id) === -1) {
                  this.onedriveRecentData.push(itm);
                  this.onedriveFilesData = cloneDeep(this.onedriveRecentData);
                  let userTimezoneOffset = this.appSession.user.userTimeZoneOffset;
                  let todayAsCurrUser = moment(new Date()).utc().utcOffset(userTimezoneOffset).format('YYYY-MM-DD');
                  let yesterdayAsCurrUser = moment(new Date()).utc().add(-1, 'day').utcOffset(userTimezoneOffset).format('YYYY-MM-DD');
                  let earlyWeekEndAsCurrUser = moment(new Date()).utc().add(-2, 'day').utcOffset(userTimezoneOffset);
                  let earlyWeekStartAsCurrUser = moment(new Date()).utc().add(-7, 'day').utcOffset(userTimezoneOffset);
                  let lastWeekEndAsCurrUser = moment(new Date()).utc().add(-8, 'day').utcOffset(userTimezoneOffset);
                  let lastWeekStartAsCurrUser = moment(new Date()).utc().add(-14, 'day').utcOffset(userTimezoneOffset);
                  let olderStartAsCurrUser = moment(new Date()).utc().add(-15, 'day').utcOffset(userTimezoneOffset);

                  if ((element.lastModifiedDateTime as any).year() < moment(new Date()).utc().utcOffset(userTimezoneOffset).year() &&
                    (element.lastModifiedDateTime as any).diff(moment(new Date()).utc().utcOffset(userTimezoneOffset), 'day') < -14) {
                    this.olderFiles.push(itm);
                  } else {
                    if (todayAsCurrUser === (element.lastModifiedDateTime as any).format('YYYY-MM-DD')) {
                      this.todayFiles.push(itm);
                    } else if (yesterdayAsCurrUser === (element.lastModifiedDateTime as any).format('YYYY-MM-DD')) {
                      this.yesterdayFiles.push(itm);
                    } else if ((element.lastModifiedDateTime as any) >= earlyWeekStartAsCurrUser &&
                      (element.lastModifiedDateTime as any) <= earlyWeekEndAsCurrUser) {
                      this.earlyThisWeekFiles.push(itm);
                    } else if ((element.lastModifiedDateTime as any) >= lastWeekStartAsCurrUser &&
                      (element.lastModifiedDateTime as any) <= lastWeekEndAsCurrUser) {
                      this.lastWeekFiles.push(itm);
                    } else if ((element.lastModifiedDateTime as any) < olderStartAsCurrUser) {
                      this.olderFiles.push(itm);
                    }
                  }
                }
              });
              this.loadFilesCountFrom += this.onedriveRecentData.length;
            } else {
              this.loadFilesCountFrom = 50;
            }
          }
          this.isLoadingFiles = false;
        });
      }
    }
  }

  getMyFiles(showShimmer) {
    // write code to get my files from onedrive
    this.isSharePointSitesLoading = true;
    this.nextBatchLink = '';
    // this._oneDriveService.getMyFilesOnOneDrive().subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         element.isShow = true;
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //     this.setItems(this.driveItems);
    //   }
    // });
    this._oneDriveService.getMsFiles(undefined, undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
            });
          } else {
            this.isFolderEmpty = true;
          }
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      } else {
        const errorDef = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
        this.fileLoadError = errorDef;
        this.fileLoadErrorShell.show();
      }
    });
  }

  getMoreMyFiles(event?: any) {
    if (this.nextBatchLink !== '' && !this.isSharePointSitesLoading && this.currentTab === 2) {
      this.isSharePointSitesLoading = true;
      this._oneDriveService.getMsFiles(undefined, undefined, this.nextBatchLink, undefined).subscribe(result => {
        this.isSharePointSitesLoading = false;
        if (!result.isError) {
          if (result.responseData) {
            if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
              this.driveItems.push(...result.responseData['item1']);
              this.driveItems.forEach(element => {
                element.isSelected = false;
                element.isShow = true;
              });
            }
            if (result.responseData['item2']) {
              this.nextBatchLink = result.responseData['item2'];
            } else {
              this.nextBatchLink = '';
            }
          }
        } else {
          const errorDef = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
          this.fileLoadError = errorDef;
          this.fileLoadErrorShell.show();
        }
      });
    }
  }

  getSharePoint() {
    // write code to get sharepoint files
    this.getSharepointSites();
  }

  applyRecentLinkSearch() {
  }

  clearRecentLinkSearch() {
    this.onedriveRecentData.forEach(element => {
      element.isHide = false;
    });
  }

  closeFiles() {
    $('.right-side-bar-files').toggleClass('collapsed');
    $('.main-grid').toggleClass('main-grid-with-right-sidebar-collapsed');
    $('body').removeClass('rightsidebar-open');
    $('#rsidebar-arrow').show();
    $('.fileSearch .form-control').off();
    $('.fileSearch .input-group-append').off();
    this.onSliderClose('files');
    this.closeEmit.emit();
    this.resetValues();
  }

  private checkIsAccountLinked() {
    this.isLoading = true;
    this._userServiceProxy.getNeedToRelinkUsers().subscribe((result) => {
      this.isLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData.length > 0) {
            result.responseData.forEach(x => {
              if (x.emailAddress === this.appSession.user.emailAddress) {
                this.isAccLinked = false;
                this.dataService.isAccLinked = false;
              }
            });
          } else {
            this.isAccLinked = true;
            this.dataService.isAccLinked = true;
            this.dataService.isAccountLinked.next(true);
          }
        }
      }
    });
  }

  show() {
    this.currentTab = 1;
    this.onSliderOpen('files', undefined);
    this.checkIsAccountLinked();
    $('.fileSearch .input-group-append').hide();
    $('.fileSearch .form-control').on('keyup blur', function (event) {
      setTimeout(() => {
        let divapp = $('.fileSearch .input-group-append');
        if ($('.fileSearch .form-control').val() !== '') {
          $(this).addClass('focus');
          divapp.show();
        } else {
          divapp.hide();
          $(this).removeClass('focus');
        }
      }, 50);
    });
    $('.fileSearch .input-group-append').on('click', function () {
      $('.fileSearch .form-control').trigger('focus');
      $(this).hide();
    });
    $('.right-side-bar-files').toggleClass('collapsed');

    if (!$('.right-side-bar-files').hasClass('collapsed')) {
      if (!$('body').hasClass('rightsidebar-open')) {
        $('body').addClass('rightsidebar-open');
      }
      $(this).addClass('active');
    } else {
      $('body').removeClass('rightsidebar-open');
    }
    $(this).addClass('active');
    this.getApiSettings();
    this.loadFilesCountFrom = 1;
    this.refreshTabsData();
    // this.getAllGroups();
    // loaders on team drive tab
    this.isDriveCategoryLoading = true;
    this.teamDriveCategoryData = [];
    this.teamDriveData = [];
    this.isTeamDataLoading = true;
    this.initializeScroll();
    this.getUserSections();
    // this._linkService.getOnedriveLinks().subscribe((result) => {
    //   this.myOneDriveLink = '';
    //   if (result.responseData && result.responseData.length > 0) {
    //     result.responseData.forEach(element => {
    //       if (element.name.toLocaleLowerCase() === 'my files') {
    //         this.myOneDriveLink = element.webUrl;
    //       }
    //     });
    //   }
    // });

  }
  openFilter() {
    setTimeout(() => {
      $('body').on('click', function (ev) {
        if (ev.target.closest('.file-filter-modal') === null) {
          $('.file-filter-modal').modal('hide');
          $('body').off();
        } else {
          return;
        }
      });
    }, 500);
  }
  triggerFileControl(): void {
    $('#fileUploadOneDrive_MyFiles').trigger('click');
  }

  createLink(item): void {
    this._linkService.createOrUpdateLink(item).subscribe(result => {
      if (!result.isError) {
        this.refreshTabsData();
        this.isLoading = false;
      }
    });
  }

  openAddEditQuickLink(item?): void {
    item.id = item.linkId;
    this.openAddEditQuickLinkModalEmit.emit(item);
    $('body').addClass('task-modal-body');
  }

  applySearchFiles() {
    this.searchText = this.searchText.trim();
    if (this.searchText.trim() !== '') {
      this.isSearchApplied = true;
      this.noMatchingRecentSearch = false;
      this.loadFilesCountFrom = 1;
    } else {
      this.isSearchApplied = false;
    }
    if (this.currentTab === 1) {
      this.teamDriveCategoryData = [];
      this.teamDriveData = [];
      this.isTeamDataLoading = true;
    }
    if (this.currentTab === 2) {
      this.applySearchOnLevel0();
    } else if (this.currentTab === 3) {
      this.applySearchOnLevel1();
    } else {
      this.onSearching.next();
    }
  }

  applySearchOnLevel0() {
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) {
          element.isShow = true;
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel0();
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel0() {
    this.searchText = '';
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        element.isShow = true;
      });
      this.checkIfItemsToShowOnLevel0();
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel0() {
    let noOfIsShowItems = this.driveItems.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  removeSearch() {
    this.loadFilesCountFrom = 1;
    this.resetSearchObjects();
    if (this.currentTab === 2) {
      this.removeSearchOnLevel0();
    } else if (this.currentTab === 3) {
      this.removeSearchOnLevel1();
    } else {
      this.refreshTabsData();
    }
  }

  resetSearchObjects() {
    this.searchText = '';
    this.isSearchApplied = false;
    this.noMatchingRecentSearch = false;
  }

  /**
   * Favorites a row from the files browser. It used to mint a duplicate TrLinks copy of the item just
   * to have something to pin; now the item gets its own TrAttachments row and that is what is pinned.
   * A web link keeps IsLink set, which is what gives it the Link pill rather than a File one.
   */
  addFilesToShortcut(linkitem) {
    if (this.isSaving) {
      return;
    }

    if (this.warnIfAlreadyFavorite(linkitem)) {
      return;
    }

    const isWebLink = Number(linkitem?.type) === 2;

    const attachment = new CommonAttachment();
    // A favorited item belongs to nothing else, so it hangs off the user.
    attachment.entity = LookUpTables._25; // AllUserIncludeMe
    attachment.entityId = this.appSession.userId;
    attachment.id = 0;
    attachment.fileName = linkitem.name;
    // Every link writer stores "Other" — a web link has no extension of its own.
    attachment.fileType = isWebLink ? 'Other' : linkitem.extension;
    attachment.isLink = isWebLink;
    attachment.isShareFile = false;
    attachment.isAddToShortcut = false;
    attachment.isDefault = false;

    // Same branching the TrLinks writer used: type 1 is a cloud item with the full Graph coordinates,
    // type 4 carries a web URL but no ids, and type 2 is a plain link.
    if (isWebLink) {
      attachment.filePath = linkitem.url;
      attachment.webLink = linkitem.url;
    } else {
      attachment.filePath = linkitem.webUrl;
      attachment.webLink = linkitem.webUrl;
      if (Number(linkitem?.type) === 1) {
        attachment.keyId = linkitem.id;
        attachment.msDriveId = linkitem.driveId;
        attachment.msSiteId = linkitem.siteId;
        attachment.msFolderId = linkitem.folderId;
      }
    }

    this.isSaving = true;
    this._attachmentService.createAttachment(attachment).pipe(
      switchMap(created => {
        if (created.isError || !created.responseData) {
          return of({ isError: true, errorMessage: created.errorMessage, pinId: undefined as number | undefined });
        }
        const favorite = new AddFavoriteInput();
        favorite.entityId = created.responseData;
        favorite.type = EntityType._8; // Attachment
        return this._favoriteService.addFavorite(favorite).pipe(
          map(res => ({ isError: res.isError, errorMessage: res.errorMessage, pinId: res.responseData?.pinId })));
      })
    ).subscribe(result => {
      this.isSaving = false;
      if (!result.isError) {
        this.markFavorited(linkitem, result.pinId);
        let options = this.toastrOptions;
        this.toastr
          .success('Added to favorites.',
            null, options);
      } else {
        if (result.errorMessage?.toLocaleLowerCase() === 'duplicate') {
          let options = this.toastrOptions;
          this.toastr
            .error('Already added to favorites.',
              null, options);
        } else {
          let options = this.toastrOptions;
          this.toastr
            .error('Error while adding to favorites.',
              null, options);
        }
      }
    });
  }

  /**
   * "Add to favorites" is a one-way button, not a toggle, so a second click has to be stopped here
   * rather than by the server. It cannot be caught there: each click calls CreateAttachment first,
   * which always inserts, so the pin that follows is for a brand-new entity id and never looks like a
   * duplicate. Left unguarded, clicking twice produced two attachment rows and two favorites.
   *
   * Reads the pin id the row carries — `isPinned` on a row that came from the server already favorited,
   * `pinnedEntityId` once markFavorited has stamped one on from an add in this session.
   */
  private warnIfAlreadyFavorite(item: any): boolean {
    if (!item?.isPinned && !item?.pinnedEntityId) {
      return false;
    }

    this.toastr.error('Already added to favorites.', null, this.toastrOptions);
    return true;
  }

  /** Records the pin the add just returned, so the next click on the same row is caught above. */
  private markFavorited(item: any, pinId: number | undefined): void {
    if (item) {
      item.isPinned = true;
      item.pinnedEntityId = Number(pinId) || item.pinnedEntityId;
    }
  }

  /** My files row — same as addFilesToShortcut, but the Graph coordinates sit on parentReference. */
  addMyFilesToShortcut(linkitem, isDocLibrary) {
    if (this.isSaving) {
      return;
    }

    if (this.warnIfAlreadyFavorite(linkitem)) {
      return;
    }

    const parent = linkitem.parentReference;

    const attachment = new CommonAttachment();
    // A favorited file belongs to nothing else, so it hangs off the user.
    attachment.entity = LookUpTables._25; // AllUserIncludeMe
    attachment.entityId = this.appSession.userId;
    attachment.id = 0;
    attachment.fileName = linkitem.name;
    attachment.filePath = linkitem.webUrl;
    attachment.webLink = linkitem.webUrl;
    attachment.fileType = isDocLibrary ? 'documentLibrary' : linkitem.extension;
    attachment.keyId = linkitem.id;
    attachment.msDriveId = parent ? parent.driveId : linkitem.id;
    attachment.msSiteId = parent ? parent.siteId : null;
    attachment.msFolderId = parent ? parent.id : null;
    attachment.isLink = false;
    attachment.isShareFile = false;
    attachment.isAddToShortcut = false;
    attachment.isDefault = false;

    this._attachmentService.createAttachment(attachment).pipe(
      switchMap(created => {
        if (created.isError || !created.responseData) {
          return of({ isError: true, errorMessage: created.errorMessage, pinId: undefined as number | undefined });
        }
        const favorite = new AddFavoriteInput();
        favorite.entityId = created.responseData;
        favorite.type = EntityType._8; // Attachment
        return this._favoriteService.addFavorite(favorite).pipe(
          map(res => ({ isError: res.isError, errorMessage: res.errorMessage, pinId: res.responseData?.pinId })));
      })
    ).subscribe(result => {
      this.isSaving = false;
      this.dataService.refreshFilesSlider.next();
      if (!result.isError) {
        this.markFavorited(linkitem, result.pinId);
        let options = this.toastrOptions;
        this.toastr
          .success('Added to favorites.',
            null, options);
      } else {
        if (result.errorMessage?.toLocaleLowerCase() === 'duplicate') {
          let options = this.toastrOptions;
          this.toastr
            .error('Already added to favorites.',
              null, options);
        } else {
          let options = this.toastrOptions;
          this.toastr
            .error('Error while adding to favorites.',
              null, options);
        }
      }
    });
  }

  onSearchTyping() {
    this.isSearchApplied = false;
  }

  okQuickLinkBtnClick(ev: any): void {
    if (ev.toggle) {
      if (ev.obj) {
        if (ev.obj.tblId === 9) {
          this.deleteDefaultApp(ev.obj);
        } else {
          this.deleteQuickLink(ev.obj);
        }
      }
    }
    this.delQLinkItem = undefined;
  }

  deleteDefaultApp(item): void {
    if (typeof item.id === 'string') {
      // show toastr message for refresh app
      this.toastr.success('Error deleting the shortcut, please try again.', '', this.toastrOptions);
      this.getShortcuts();
      return;
    }
    this._linkService.deleteApp(this.appSession.user.id, item.id).subscribe(result => {
      if (!result.isError) {
        if (item.type) {
          if (item.type === 3) {
            this.getShortcuts();
          }
        }
      }
    });
  }

  deleteQuickLink(item): void {
    if (typeof item.id === 'string') {
      // show toastr message for refresh app
      this.toastr.success('Error deleting the shortcut, please try again.', '', this.toastrOptions);
      this.getShortcuts();
      return;
    }
    this._linkService.deleteUserShortcut(item.id)
      .subscribe((result) => {
        if (!result.isError) {
          this.getShortcuts();
        }
      });
  }

  addFileTask(item: any) {
    let input: CreateTaskFromAgendaInput = new CreateTaskFromAgendaInput();
    input.taskName = item.name;
    input.description = '';
    input.progressCompleted = 0;
    input.isMeasureProgressByChecklist = false;
    input.isActive = true;
    input.ownerId = this.appSession.userId;
    input.assignedToUserId = this.appSession.userId;
    input.projectId = null;
    input.sectionId = null;
    input.isPrivate = false;
    input.priority = 1;
    input.startDate = moment.parseZone(this.appSession.user.companyTzWorkDate).utc(true) as any;
    input.dueDate = moment.parseZone(this.appSession.user.companyTzWorkDate).utc(true) as any;
    input.code = 111;
    let ext = item.extension;
    if (ext !== '' && (ext === 'doc' || ext === 'docx')) {
      input.resourceAppName = item.extension;
    } else if (ext !== '' && (ext === 'xls' || ext === 'xlsx')) {
      input.resourceAppName = item.extension;
    } else if (ext !== '' && (ext === 'ppt' || ext === 'pptx')) {
      input.resourceAppName = item.extension;
    } else if (ext !== '' && ext === 'pdf') {
      input.resourceAppName = item.extension;
    } else if (ext === 'jpg' || ext === 'jpeg' || ext === 'gif' || ext === 'bmp' || ext === 'svg' || ext === 'png') {
      input.resourceAppName = item.extension;
    } else {
      input.resourceAppName = 'otherfile';
    }
    input.resourceAppUrl = item.pinnedEntityId ? item.url : item.webUrl;
    input.actionPerformed = 'createtaskmyday';
    this.dataService.addOtherTaskToAgenda.next([input, false]);
  }

  clearFilters(): void {
    $('body').off();
    this.onedriveRecentData.forEach(element => {
      element.isHide = false;
    });
    this.pinnedFilesData.forEach(element => {
      element.isHide = false;
    });
    this.isWordChecked = false;
    this.isExcelChecked = false;
    this.isPPChecked = false;
    this.isPDFChecked = false;

    this.isHideToday = false;
    this.isHideYesterday = false;
    this.isHideEarly = false;
    this.isHideLastWeek = false;
    this.isHideOlder = false;
    this.isHidePinnedFiles = false;

    this.isSearchApplied = false;
    this.noMatchingRecentSearch = false;

    // this.filterFiles();
  }

  typeChanged(type: string): void {
    if (type.toLocaleLowerCase() === 'word') {
      this.isWordChecked = !this.isWordChecked;
    } else if (type.toLocaleLowerCase() === 'excel') {
      this.isExcelChecked = !this.isExcelChecked;
    } else if (type.toLocaleLowerCase() === 'pp') {
      this.isPPChecked = !this.isPPChecked;
    } else if (type.toLocaleLowerCase() === 'pdf') {
      this.isPDFChecked = !this.isPDFChecked;
    }
    this.filterFiles();
  }

  filterFiles(): void {
    this.onedriveRecentData.forEach(element => {
      element.isHide = false;
    });
    this.pinnedFilesData.forEach(element => {
      element.isHide = false;
    });
    this.isHideToday = false;
    this.isHideYesterday = false;
    this.isHideEarly = false;
    this.isHideLastWeek = false;
    this.isHideOlder = false;
    this.isHidePinnedFiles = false;
    this.onedriveRecentData.forEach(element => {
      if (this.isWordChecked && this.isExcelChecked && this.isPPChecked && this.isPDFChecked) {
        // all doc,xls,ppt,pdf selected
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && this.isExcelChecked && this.isPPChecked && !this.isPDFChecked) {
        // doc,xls,ppt
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && this.isExcelChecked && !this.isPPChecked && this.isPDFChecked) {
        // doc,xls,pdf
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && !this.isExcelChecked && this.isPPChecked && this.isPDFChecked) {
        // doc,ppt,pdf
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && this.isExcelChecked && this.isPPChecked && this.isPDFChecked) {
        // xls,ppt,pdf
        if (element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && this.isExcelChecked && !this.isPPChecked && !this.isPDFChecked) {
        // doc,xls
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && !this.isExcelChecked && this.isPPChecked && !this.isPDFChecked) {
        // doc,ppt
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && !this.isExcelChecked && !this.isPPChecked && this.isPDFChecked) {
        // doc,pdf
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && this.isExcelChecked && this.isPPChecked && !this.isPDFChecked) {
        // xls,ppt
        if (element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && this.isExcelChecked && !this.isPPChecked && this.isPDFChecked) {
        // xls,pdf
        if (element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && !this.isExcelChecked && this.isPPChecked && this.isPDFChecked) {
        // ppt,pdf
        if (element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && !this.isExcelChecked && !this.isPPChecked && !this.isPDFChecked) {
        // doc only
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && this.isExcelChecked && !this.isPPChecked && !this.isPDFChecked) {
        // xls only
        if (element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && !this.isExcelChecked && this.isPPChecked && !this.isPDFChecked) {
        // ppt only
        if (element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && !this.isExcelChecked && !this.isPPChecked && this.isPDFChecked) {
        // pdf only
        if (element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      }
    });
    this.pinnedFilesData.forEach(element => {
      if (this.isWordChecked && this.isExcelChecked && this.isPPChecked && this.isPDFChecked) {
        // all doc,xls,ppt,pdf selected
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && this.isExcelChecked && this.isPPChecked && !this.isPDFChecked) {
        // doc,xls,ppt
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && this.isExcelChecked && !this.isPPChecked && this.isPDFChecked) {
        // doc,xls,pdf
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && !this.isExcelChecked && this.isPPChecked && this.isPDFChecked) {
        // doc,ppt,pdf
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && this.isExcelChecked && this.isPPChecked && this.isPDFChecked) {
        // xls,ppt,pdf
        if (element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && this.isExcelChecked && !this.isPPChecked && !this.isPDFChecked) {
        // doc,xls
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && !this.isExcelChecked && this.isPPChecked && !this.isPDFChecked) {
        // doc,ppt
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && !this.isExcelChecked && !this.isPPChecked && this.isPDFChecked) {
        // doc,pdf
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && this.isExcelChecked && this.isPPChecked && !this.isPDFChecked) {
        // xls,ppt
        if (element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && this.isExcelChecked && !this.isPPChecked && this.isPDFChecked) {
        // xls,pdf
        if (element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && !this.isExcelChecked && this.isPPChecked && this.isPDFChecked) {
        // ppt,pdf
        if (element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt'
          || element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (this.isWordChecked && !this.isExcelChecked && !this.isPPChecked && !this.isPDFChecked) {
        // doc only
        if (element.extension.toLowerCase() === 'docx' || element.extension.toLowerCase() === 'doc') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && this.isExcelChecked && !this.isPPChecked && !this.isPDFChecked) {
        // xls only
        if (element.extension.toLowerCase() === 'xlsx' || element.extension.toLowerCase() === 'xls') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && !this.isExcelChecked && this.isPPChecked && !this.isPDFChecked) {
        // ppt only
        if (element.extension.toLowerCase() === 'pptx' || element.extension.toLowerCase() === 'ppt') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      } else if (!this.isWordChecked && !this.isExcelChecked && !this.isPPChecked && this.isPDFChecked) {
        // pdf only
        if (element.extension.toLowerCase() === 'pdf') {
          element.isHide = false;
        } else {
          element.isHide = true;
        }
      }
    });
    let todayFiltered = this.todayFiles.filter(t => t.isHide === false);
    if (todayFiltered.length === 0) {
      this.isHideToday = true;
    }
    let yesterdayFiltered = this.yesterdayFiles.filter(t => t.isHide === false);
    if (yesterdayFiltered.length === 0) {
      this.isHideYesterday = true;
    }
    let earlyFiltered = this.earlyThisWeekFiles.filter(t => t.isHide === false);
    if (earlyFiltered.length === 0) {
      this.isHideEarly = true;
    }
    let lastWeekFiltered = this.lastWeekFiles.filter(t => t.isHide === false);
    if (lastWeekFiltered.length === 0) {
      this.isHideLastWeek = true;
    }
    let olderFiltered = this.olderFiles.filter(t => t.isHide === false);
    if (olderFiltered.length === 0) {
      this.isHideOlder = true;
    }
    let pinnedFiltered = this.pinnedFilesData.filter(t => t.isHide === false);
    if (pinnedFiltered.length === 0) {
      this.isHidePinnedFiles = true;
    }
    if (this.isHideToday && this.isHideYesterday && this.isHideEarly && this.isHideLastWeek && this.isHideOlder && this.isHidePinnedFiles) {
      this.isSearchApplied = true;
      this.noMatchingRecentSearch = true;
    } else {
      this.isSearchApplied = false;
      this.noMatchingRecentSearch = false;
    }
  }

  openCreateFileModal(fileType: string): void {
    this.selectedFileType = fileType;
    this.dataService.openAddDocModal.next([this.selectedFileType, '']);
  }

  relink() {
    this.dataService.showTokenLink.next();
  }

  checkNoDataForRecentFiles(): void {
    if (!this.isSearchApplied && this.pinnedFilesData.length === 0 && this.onedriveRecentData.length === 0) {
      this.noDataForRecentFilesTab = true;
    } else {
      this.noDataForRecentFilesTab = false;
    }
  }

  openOneDrivePickerForFolders(): void {
    let that = this;
    let odOptions = {
      clientId: that.clientId,
      action: 'share',
      multiSelect: false,
      viewType: 'folders',
      advanced: {},
      success: function (files) {
        /* success handler */
        if (files.message === 400) {
          that.isLocationError = true;
          return;
        } else {
          that.isLocationError = false;
        }
        if (files.value.length > 0) {
          files.value.forEach(element => {
            // let input: LinkDto = new LinkDto();
            // input.id = 0;
            // input.isCompanyLink = false;
            // input.type = element.folder ? LinkDtoType._3 : LinkDtoType._1;
            // input.name = element.name;
            // input.url = element.webUrl;
            // input.scope = LinkScope._0;
            // input.pinnedEntityId = undefined;
            that.itemId = element.id;
            that.driveId = element.parentReference.driveId;
            that.driveType = element.parentReference.driveType;
            if (that.driveType.toLocaleLowerCase() === 'business') {
              let path = element.parentReference.path.split(':');
              if (path && path.length > 1) {
                if (path[1] !== '') {
                  that.oneDrivePath = path[1] + '/' + element.name;
                } else {
                  that.oneDrivePath = '/' + element.name;
                }
              }
            } else if (that.driveType.toLocaleLowerCase() === 'documentlibrary') {
              let path = element.parentReference.path.split(':');
              if (path && path.length > 1) {
                if (path[1] !== '') {
                  that.sharePointPath = path[1] + '/' + element.name;
                } else {
                  that.sharePointPath = '/' + element.name;
                }
              }
            }
          });
        }
      },
      cancel: function () {
        /* cancel handler */
      },
      error: function (error) {
        /* error handler */
        console.log(error);
      }
    };
    oneDrive.open(odOptions);
  }

  openFileLocation(item): void {
    this._oneDriveService.getFileFolderUrl(undefined, item.driveId, undefined, item.folderId).subscribe(result => {
      if (!result.isError) {
        if (result.responseData && result.responseData.folderUrl) {
          window.open(result.responseData.folderUrl, '_blank');
        } else {
          // error fetching folder url
        }
      } else {
        // error fetching folder url
      }
    });
  }

  private openAddEditWeblinkModal(categoryId) {
    this.groupLinkObj = new GroupLinkDto();
    this.groupLinkObj.driveCategoryId = categoryId;
    this.groupLinkObj.isEveryone = true;

    this.addEditWeblinkModal.show();
    this.updateBodyForCenterModalShow();
  }

  closeAddEditWeblinkModal() {
    this.clearGroupData();
    this.isInvalidUrl = false;
    this.addEditWeblinkModal.hide();
    this.updateBodyForCenterModalHide();
  }

  private resetValues2() {
    this.uploadingItems2 = [];
    this.fileType = '';
    this.oneDrivePath = '';
    this.sharePointPath = '';
    this.driveType = '';
    this.isSharePointSelected = false;
    this.isOneDriveSelected = false;
  }

  saveWeblink() {
    this.isInvalidUrl = false;
    let input: GroupLinkDto = new GroupLinkDto();
    if (this.groupLinkObj.id > 0) { input.id = this.groupLinkObj.id; }
    input.type = 3; // 2 for weblink
    // input.type = 3; // 3 for shortcut
    input.name = this.groupLinkObj.name;
    if (!this.groupLinkObj.url.startsWith('http')) {
      input.url = 'http://' + this.groupLinkObj.url;
    } else {
      input.url = this.groupLinkObj.url;
    }
    const urlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;

    if (!urlPattern.test(input.url)) {
      this.isInvalidUrl = true;
      return;
    }
    input.isShareFile = false;
    input.isEveryone = this.groupLinkObj.isEveryone;
    input.driveCategoryId = this.groupLinkObj.driveCategoryId;
    // input.isShareFile = true; // onl for type = 3 and isOnedrive
    input.groupArr = ''; // for type = 3
    if (!this.groupLinkObj.isEveryone) {
      let grpArr = new Array<GroupDto>();
      if (this.groupData.filter(x => x.isChecked === true).length > 0) {
        this.groupData.filter(x => x.isChecked === true).forEach(element => {
          let grp: GroupDto = new GroupDto();
          grp.groupId = element.id;
          grp.groupName = element.name;
          grpArr.push(grp);
        });
      }
      if (grpArr.length > 0) {
        input.groupArr = JSON.stringify(grpArr);
      } else {
        input.groupArr = '';
      }
    }
    this.isSaving = true;
    this._linkService.createOrUpdateGroupLink(input).subscribe((result) => {
      this.isSaving = false;
      if (!result.isError) {
        let tmp = new GroupLinkDto();
        tmp.name = input.name;
        tmp.url = input.url;
        tmp.id = result.responseData;
        tmp.driveCategoryId = input.driveCategoryId;

        let tmpcat = this.teamDriveCategoryData.filter(x => x.id === input.driveCategoryId);
        if (tmpcat.length > 0) {
          // check if the link is already added
          let index = tmpcat[0].links.findIndex(x => x.id === tmp.id);
          if (index === -1) {
            tmpcat[0].links.unshift(tmp);
            tmpcat[0].noOfItems = tmpcat[0].noOfItems + 1;
          } else {
            tmpcat[0].links[index].name = tmp.name;
            tmpcat[0].links[index].url = tmp.url;
          }
        }
        this.sortDriveLinks();
        this.closeAddEditWeblinkModal();
      } else {
        if (result.errorMessage.toLocaleLowerCase() === 'duplicate') {
          this.isSaving = false;
          let options = this.toastrOptions;
          this.toastr
            .error('Link already added to team drive.',
              null, options);
        } else {
          this.isSaving = false;
          let options = this.toastrOptions;
          this.toastr
            .error('Error while adding to team drive.',
              null, options);
        }
      }
    });
  }

  addWeblink(categoryId): void {
    this.openAddEditWeblinkModal(categoryId);
  }

  editWeblink(item, categoryId): void {
    this.groupLinkObj = cloneDeep(item);
    this.groupLinkObj.driveCategoryId = categoryId;
    this.groupLinkObj.isEveryone = true;
    this.addEditWeblinkModal.show();
    this.updateBodyForCenterModalShow();
  }

  changeCheckedState(item: any): void {
    item.isChecked = !item.isChecked;
  }


  deleteShortcut(item): void {
    if (item) {
      this._linkService.deleteGroupLink(item.id).subscribe(res => {

      });
      let tmp = this.teamDriveCategoryData.filter(x => x.id === item.driveCategoryId);
      if (tmp.length > 0) {
        let index = tmp[0].links.indexOf(item);
        if (index > -1) {
          tmp[0].links.splice(index, 1);
          tmp[0].noOfItems = tmp[0].noOfItems - 1;
        }
      }
      this.teamDriveData.forEach(section => {
        if (section.id === item.id) {
          let index = this.teamDriveData.indexOf(item);
          if (index > -1) {
            this.teamDriveData.splice(index, 1);
          }
        }
      });
    }
  }

  okBtnClick(ev: any) {
    if (ev.toggle) {
      if (ev.obj) {
        this.deleteShortcut(ev.obj);
      }
    }
    this.delTeamItem = undefined;
  }

  // Add item to shortcuts
  addToShortcuts(item): void {
    if (this.warnIfAlreadyFavorite(item)) {
      return;
    }

    if (!item.url.startsWith('http')) {
      item.url = 'http://' + item.url;
    }

    // The quick link stays a TrLinks row for the Files page, but favoriting it mints the user-scoped
    // attachment that favorites are made of — TrLinks is not part of favorites any more.
    const attachment = new CommonAttachment();
    attachment.entity = LookUpTables._25; // AllUserIncludeMe
    attachment.entityId = this.appSession.userId;
    attachment.id = 0;
    attachment.fileName = item.name;
    attachment.filePath = item.url;
    attachment.webLink = item.url;
    attachment.fileType = 'Other';
    attachment.keyId = null;
    attachment.isLink = true;
    attachment.isShareFile = false;
    attachment.isAddToShortcut = false;
    attachment.isDefault = false;

    this._attachmentService.createAttachment(attachment).pipe(
      switchMap(created => {
        if (created.isError || !created.responseData) {
          return of({ isError: true, errorMessage: created.errorMessage, pinId: undefined as number | undefined });
        }
        const favorite = new AddFavoriteInput();
        favorite.entityId = created.responseData;
        favorite.type = EntityType._8; // Attachment
        return this._favoriteService.addFavorite(favorite).pipe(
          map(res => ({ isError: res.isError, errorMessage: res.errorMessage, pinId: res.responseData?.pinId })));
      })
    ).subscribe(result => {
      if (!result.isError) {
        this.markFavorited(item, result.pinId);
        let options = this.toastrOptions;
        this.toastr
          .success('Added to favorites.',
            null, options);
      } else {
        if (result.errorMessage.toLocaleLowerCase() === 'duplicate') {
          let options = this.toastrOptions;
          this.toastr
            .error('Already added to favorites.',
              null, options);
        } else {
          let options = this.toastrOptions;
          this.toastr
            .error('Error while adding to favorites.',
              null, options);
        }
      }
    });
  }

  openContentManagers() {
    this.dataService.openContentManagersModal.next();
  }

  addNewCategory() {
    this.isAddNewCategoryClicked = true;
    $('#NewDriveCategoryForm').removeClass('d-none');
    $('#NewDriveCategoryForm').addClass('d-flex');
    $('#newDriveCategoryInput').trigger('focus');
  }

  onCategoryKeyPress(event: any): boolean {
    let value: string = event.target.value.trim();
    let len = value.length;
    this.showDuplicateCategoryError = false;
    if (len === 0) {
      return;
    }
    if (event.keyCode === 13) {
      this.onCategoryAdd();
    }
    return event.keyCode !== 13;
  }

  onCategoryNameBlur() {
    setTimeout(() => {
      if (!this.isCategorySaving) {
        this.hideAddDriveCategoryForm();
      }
      setTimeout(() => {
        this.newDriveCategoryName = '';
      }, 500);
    }, 500);
  }

  onCategoryAdd() {
    this.isCategorySaving = true;
    if (this.newDriveCategoryName.trim() !== '') {
      let tmpDriveCategory = new DriveCategoryInputDto();
      tmpDriveCategory.id = 0;
      tmpDriveCategory.name = this.newDriveCategoryName.trim();
      tmpDriveCategory.scope = 1;
      (tmpDriveCategory as any).entityIds = [];
      this.showDuplicateCategoryError = false;
      this.hideAddDriveCategoryForm();
      this._linkService.createOrUpdateDriveCategory(tmpDriveCategory)
        .subscribe((result) => {
          this.isCategorySaving = false;
          $('#newDriveCategoryInput').trigger('focus');
          if (!result.isError) {
            this.newDriveCategoryName = '';
            tmpDriveCategory.id = result.responseData;
            let tmp: any;
            tmp = cloneDeep(tmpDriveCategory);
            tmp.noOfItems = 0;
            tmp.links = [];
            this.teamDriveCategoryData.unshift(tmp);
            this.sortDriveCategories(this.teamDriveCategoryData);
            let options = this.toastrOptions;
            this.toastr
              .success('Successfully created category <b>"' + tmpDriveCategory.name + '"</b>.',
                null, options);
          } else {
            this.showDuplicateCategoryError = true;
          }
        });
    }
  }

  hideAddDriveCategoryForm() {
    $('#NewDriveCategoryForm').addClass('d-none');
    $('#NewDriveCategoryForm').removeClass('d-flex');
    this.isAddNewCategoryClicked = false;
  }

  okDriveCategoryBtnClick(ev: any): void {
    if (ev.toggle) {
      if (ev.obj) {
        this.deleteDriveCategory(ev.obj);
      }
    }
    this.delDriveCategoryItem = undefined;
  }

  deleteDriveCategory(item): void {
    if (item) {
      this._linkService.deleteDriveCategory(item.id).subscribe(res => {
        if (res) {
          let index = this.teamDriveCategoryData.indexOf(item);
          if (index > -1) {
            this.teamDriveCategoryData.splice(index, 1);
          }
        }
      });
    }
  }

  onCategoryNameKeyPress(event: any, item: any): boolean {
    this.showBlankCategoryError = false;
    let value: string = item.name.trim();
    let len = value.length;
    if (len === 0) {
      this.showBlankCategoryError = true;
      $('#errorEditing-' + item.id).addClass('d-block');
      $('#errorEditing-' + item.id).removeClass('d-none');
      return;
    }
    let tmpDriveCategory = new DriveCategoryInputDto();
    tmpDriveCategory.id = item.id;
    tmpDriveCategory.name = value;
    tmpDriveCategory.scope = item.scope;
    (tmpDriveCategory as any).entityIds = [];

    this.categoryUpdated.next(tmpDriveCategory);
    this.teamDriveCategoryData.forEach(section => {
      if (section.id === item.id) {
        section.isEditing = true;
        $('#errorEditing-' + section.sectionId).addClass('d-none');
        $('#errorEditing-' + section.sectionId).removeClass('d-block');
      } else {
        section.isEditing = false;
      }
    });

    return event.keyCode !== 13;
  }

  onCategNameBlur(event: any, item: any): void {
    this.showBlankCategoryError = false;
    let editingSec = this.teamDriveCategoryData.find(t => t.isEditing === true);
    let sec = this.teamDriveCategoryData.filter(t => t.id === editingSec.id);
    if (sec.length > 0) {
      if ($('#errorEditing-' + item.id).hasClass('d-block')) {
        editingSec.name = sec[0].name;
        $('#errorEditing-' + item.id).removeClass('d-block');
        $('#errorEditing-' + item.id).addClass('d-none');
      }
    }
    item.isEditing = false;

    $('#EditCategory-' + item.id).addClass('d-none');
    $('#EditCategory-' + item.id).removeClass('d-block');
    $('#TextCategory-' + item.id).removeClass('d-none');
  }

  saveCategory(parSection: any) {
    this._linkService.createOrUpdateDriveCategory(parSection)
      .subscribe((result) => {
        if (!result.isError) {
          let options = this.toastrOptions;
          this.toastr
            .success('Successfully updated category <b>"' + parSection.name + '"</b>.',
              null, options);
          let editingSec = this.teamDriveCategoryData.find(t => t.isEditing === true);
          // this.projSecTaskFilter = cloneDeep(this.project.projectSections);
          // this.projectSections1 = cloneDeep(this.project.projectSections.filter(t => t.sectionId !== null));
          if (editingSec) {
            editingSec.name = parSection.name;
            this.teamDriveCategoryData.forEach(element => {
              if (element.id === editingSec.id) {
                // element = cloneDeep(editingSec);
                element.isEditing = true;
                element.name = parSection.name;
                setTimeout(() => {
                  $('#category-' + element.id).trigger('focus');
                }, 500);
              }
            });
          }
          // this.project.projectSections.forEach(element => {
          //   this.setIsHideForSearch(element);
          // });
          // this.sectionEmit.emit(true);
          // this.getProjectProgress();
        } else {
          // let editingSec = this.project.projectSections.find(t => t.isEditing === true);
          // let sec = this.projSecTaskFilter.filter(t => t.sectionId === editingSec.sectionId);
          // if (sec.length > 0) {
          //   if (parSection.sectionName.trim() === '') {
          //     this.showBlankSectionError = true;
          //   } else {
          //     this.showBlankSectionError = false;
          //   }
          //   // editingSec.sectionName = sec[0].sectionName;
          //   $('#errorEditing-' + sec[0].sectionId).addClass('d-block');
          //   $('#errorEditing-' + sec[0].sectionId).removeClass('d-none');
          // }
        }
      });
  }

  editCategory(item): void {
    this.teamDriveCategoryData.forEach(section => {
      section.isEditing = false;
    });
    item.isEditing = true;
    // setTimeout(() => {
    //     if (item.isEditing === true) {
    //         $('#section-' + item.sectionId).trigger('focus');
    //     }
    // }, 1000);
    this.teamDriveCategoryData.forEach(section => {
      if (section.id) {
        $('#EditCategory-' + section.id).addClass('d-none');
        $('#EditCategory-' + section.id).removeClass('d-block');
        $('#TextCategory-' + section.id).removeClass('d-none');

        // $('#editSectionInline-' + section.sectionId).removeClass('d-none');
        // $('#deleteSection-' + section.sectionId).removeClass('d-none');
        // $('#addTaskProject-' + section.sectionId).addClass('d-flex');
        // $('#addTaskProject-' + section.sectionId).removeClass('d-none');
        // $('#errorEditing-' + section.sectionId).removeClass('d-block');
        // $('#errorEditing-' + section.sectionId).addClass('d-none');

        // $('#count-' + section.sectionId).removeClass('d-none');
      }
    });
    $('#TextCategory-' + item.id).addClass('d-none');
    $('#EditCategory-' + item.id).addClass('d-block');
    $('#TextCategory-' + item.id).removeClass('d-block');
    $('#EditCategory-' + item.id).removeClass('d-none');
    // $('#editSectionInline-' + item.sectionId).addClass('d-none');
    // $('#deleteSection-' + item.sectionId).addClass('d-none');
    // $('#addTaskProject-' + item.sectionId).removeClass('d-flex');
    // $('#addTaskProject-' + item.sectionId).addClass('d-none');
    // $('#count-' + item.sectionId).addClass('d-none');

    setTimeout(() => {
      $('#EditCategory-' + item.id).trigger('focus');
    }, 500);
  }

  goToFolder(ev, item): void {
    if (ev.target.className !== 'btn-delete'
      // && !ev.target.className.includes('lni-more-alt')
      && !ev.target.className.includes('btn-project-link-more')
      && !ev.target.offsetParent.className.includes('project-file-delete')
      && !ev.target.className.includes('lni lni-close')
      && !ev.target.offsetParent.className.includes('dropdown-menu')) {
      setTimeout(() => {
        let input = cloneDeep(item);
        input.from = 'Team Drive';
        this.dataService.openNavigationModal.next(input);
      }, 50);
    }
  }

  goToFolderFromMyFiles(ev, item): void {
    if (ev.target.className !== 'btn-delete'
      && !ev.target.className.includes('lni-more-alt')
      && !ev.target.className.includes('btn-project-link-more')
      && !ev.target.offsetParent.className.includes('project-file-delete')
      && !ev.target.className.includes('lni lni-close')
      && !ev.target.offsetParent.className.includes('dropdown-menu')) {
      setTimeout(() => {
        let input = cloneDeep(item);
        input.keyId = cloneDeep(item.id);
        input.from = 'My files';
        this.dataService.openNavigationModal.next(input);
        this.hideSelectAllBar();
      }, 50);
    }
  }

  goToFolderFromSharePoint(ev, item): void {
    if (ev.target.className !== 'btn-delete'
      && !ev.target.className.includes('lni-more-alt')
      && !ev.target.className.includes('btn-project-link-more')
      && !ev.target.offsetParent.className.includes('project-file-delete')
      && !ev.target.className.includes('lni lni-close')
      && !ev.target.offsetParent.className.includes('dropdown-menu')) {
      setTimeout(() => {
        let input = cloneDeep(item);
        input.keyId = cloneDeep(item.id);
        input.from = 'SharePoint';
        input.reqCallService = 'getDrivesBySiteId';
        this.dataService.openNavigationModal.next(input);
        this.hideSelectAllBar();
      }, 50);
    }
  }

  openInM365(item) {
    if ((item.msDriveId || item.driveId) && (item.keyId || item.id || item.fileId) && item.keyId !== item.driveId) {
      this.getFileLocation(item.keyId ? item.keyId : item.id ? item.id : item.fileId ? item.fileId : undefined, item.msDriveId ? item.msDriveId : item.driveId);
      // this._oneDriveService.getFileUrl(item.keyId ? item.keyId : item.id ? item.id : item.fileId ? item.fileId : undefined, item.msDriveId ? item.msDriveId : item.driveId, 2).subscribe(result => {
      //   if (!result.isError) {
      //     if (result.responseData) {
      //       window.open(result.responseData, '_blank');
      //     }
      //   } else {
      //     let options = this.toastrOptions;
      //     this.toastr
      //       .success('Error while fetching file url.',
      //         null, options);
      //   }
      // });
    } else {
      window.open(item.webUrl ? item.webUrl : item.filePath ? item.filePath : item.url ? item.url : undefined, '_blank');
    }
  }

  openLocationForMyFiles(item) {
    if (item.parentReference && item.parentReference.driveId && item.id) {
      this.getFileLocation(item.id, item.parentReference.driveId);
    } else {
      window.open(item.url ? item.url : item.webUrl ? item.webUrl : undefined, '_blank');
    }
  }

  closeFileLoadError(): void {
    this.fileLoadErrorShell.hide();
    this.fileLoadError = undefined;
  }

  private getFileLocation(itemId, driveId) {
    this._oneDriveService.getFileUrl(itemId, driveId, 2).subscribe(result => {
      if (!result.isError) {
        if (result.responseData) {
          window.open(result.responseData, '_blank');
        }
      } else {
        const errorDef = result.errorMessage ? AppConsts.oneDriveErrors[result.errorMessage] : {message: result.errorMessage};
        this.fileLoadError = errorDef;
        this.fileLoadErrorShell.show();
      }
    });
  }

  expandAllSections() {
    $('#TeamDriveSections .collapse').collapse('show');
    this.isSectionOpen = true;
  }

  collapseAllSections() {
    $('#TeamDriveSections .collapse').collapse('hide');
    this.isSectionOpen = false;
  }

  openShareModal(item: any) {
    let input = cloneDeep(item);
    input.fileId = cloneDeep(item.keyId);
    this.dataService.openShareFileModal.next(input);
  }

  openRenameModal(item: any) {
    let input = cloneDeep(item);
    input.type = 1;
    input.siteId = cloneDeep(item.siteId);
    input.fileName = cloneDeep(item.name);
    input.driveId = cloneDeep(item.driveId);
    input.fileId = cloneDeep(item.keyId);
    this.dataService.openRenameFileModal.next(input);
  }

  openRenameForShortcutModal(item: any) {
    let input = cloneDeep(item);
    input.type = item.entity ? cloneDeep(item.entity) : 1;
    input.siteId = cloneDeep(item.siteId);
    input.fileName = cloneDeep(item.name);
    input.driveId = cloneDeep(item.driveId);
    input.fileId = cloneDeep(item.keyId);
    this.dataService.openRenameFileModal.next(input);
  }

  addFileTaskToMyDay(item, sectionId) {
    let input = new CreateFileTask();
    input.code = 111;
    input.entity = 0;
    input.entityId = 0;
    input.id = 0;
    input.keyId = item.keyId;
    input.filePath = item.url ? item.url : item.webUrl;
    input.fileName = item.name;
    input.fileType = item.extension;
    input.webLink = item.url ? item.url : item.webUrl;
    input.isLink = item.extension ? false : true;
    input.isShareFile = false;
    input.isAddToShortcut = false;
    input.msDriveId = item.driveId;
    input.msSiteId = item.siteId ? item.siteId : '';
    input.msFolderId = item.folderId ? item.folderId : '';
    input.startDate = null;
    input.userSectionId = sectionId ? sectionId : 0;
    this.dataService.addFileTaskToAgenda.next(input);
  }

  addFileTaskToDoLater(item) {
    let input = new CreateFileTask();
    input.code = 121;
    input.entity = 0;
    input.entityId = 0;
    input.id = 0;
    input.keyId = item.keyId;
    input.filePath = item.url ? item.url : item.webUrl;
    input.fileName = item.name;
    input.fileType = item.extension;
    input.webLink = item.url ? item.url : item.webUrl;
    input.isLink = item.extension ? false : true;
    input.isShareFile = false;
    input.isAddToShortcut = false;
    input.msDriveId = item.driveId;
    input.msSiteId = item.siteId ? item.siteId : '';
    input.msFolderId = item.folderId ? item.folderId : '';
    input.startDate = null;
    this.dataService.openDoLaterModal.next(input);
  }

  openFileSelector(catId: any) {
    this.showFilePopup = true;
    this.selectedCatId = catId;
  }

  onSelectItem(ev: any) {
    this.showFilePopup = false;
    if (ev[0].length > 0) {
      ev[0].forEach(element => {
        let input: GroupLinkDto = new GroupLinkDto();
        input.type = 3;
        input.name = element.name;
        if (!element.webUrl.startsWith('http')) {
          input.url = 'http://' + element.webUrl;
        } else {
          input.url = element.webUrl;
        }
        input.isShareFile = false;
        input.isEveryone = true;
        input.keyId = element.id;
        if (element.folder && !element.file && element.package && element.package.type) {
          if (element.package.type.toLocaleLowerCase() === 'onenote') {
            // oneNote
            input.extension = 'onenote';
          }
        }
        if (!element.package && !element.file && element.folder) {
          // folder
          input.extension = 'folder';
        }
        if (!element.folder && !element.package && element.file) {
          let ext = element.name.split('.').pop();
          ext = ext !== '' ? ext.toLowerCase() : ext;
          if (ext !== '' && (ext === 'doc' || ext === 'docx')) {
            input.extension = ext;
          } else if (ext !== '' && (ext === 'xls' || ext === 'xlsx')) {
            input.extension = ext;
          } else if (ext !== '' && (ext === 'ppt' || ext === 'pptx')) {
            input.extension = ext;
          } else if (ext !== '' && ext === 'pdf') {
            input.extension = ext;
          } else if (ext !== '' && (ext === 'jpg' || ext === 'jpeg' || ext === 'gif' || ext === 'bmp' || ext === 'svg' || ext === 'png')) {
            input.extension = ext;
          } else {
            input.extension = 'otherfile';
          }
        }
        input.extension = element.parentReference ? input.extension : 'documentLibrary';
        input.driveCategoryId = this.selectedCatId;
        input.driveId = element.parentReference ? element.parentReference.driveId : element.id;
        input.siteId = ev[1] !== null ? ev[1] : undefined;
        this.poolItems.push(input);
      });
      this.savePoolItems();
    }
  }

  savePoolItems() {
    let cts = this.poolItems.length;
    this.poolItems.forEach(element => {
      this._linkService.createOrUpdateGroupLink(element).subscribe((result) => {
        if (!result.isError) {
          let tmp = new GroupLinkDto();
          tmp.name = element.name;
          tmp.url = element.url;
          tmp.id = result.responseData;
          tmp.extension = element.extension;
          tmp.driveId = element.driveId;
          tmp.keyId = element.keyId;
          tmp.siteId = element.siteId;
          tmp.driveCategoryId = element.driveCategoryId;
          let tmpcat = this.teamDriveCategoryData.filter(x => x.id === element.driveCategoryId);
          if (tmpcat.length > 0) {
            tmpcat[0].links.unshift(tmp);
            tmpcat[0].noOfItems = tmpcat[0].noOfItems + 1;
          }
          cts--;
          if (cts <= 0) {
            this.poolItems = [];
            this.sortDriveLinks();
          }
        }
      });
    });
  }

  onCloseFileSelector() {
    this.showFilePopup = false;
  }

  openAddToTaskFromTeamDrive(item) {
    this.dataService.openFileToTaskModal.next([item, 'TeamDrive']);
  }

  openAddToTask(item) {
    this.dataService.openFileToTaskModal.next([item, 'M365']);
  }

  openLinkToProject(item) {
    this.dataService.openFileToProjectModal.next([item, 'M365']);
  }

  openLinkToProjectFromTeamDrive(item) {
    this.dataService.openFileToProjectModal.next([item, 'TeamDrive']);
  }

  openShareLinkModal(item: any) {
    let input = cloneDeep(item);
    input.fileId = cloneDeep(item.id);
    input.driveId = cloneDeep(item.parentReference.driveId);
    this.dataService.openShareFileModal.next(input);
  }

  openRenameFileModal(item: any, isDocLibrary) {
    let input = cloneDeep(item);
    input.type = 0;
    // input.siteId = !isDocLibrary ? cloneDeep(item.parentReference.siteId) : this.selectedSiteData.id;
    input.siteId = !isDocLibrary ? cloneDeep(item.parentReference.siteId) : null;
    input.fileName = cloneDeep(item.name);
    input.driveId = !isDocLibrary ? cloneDeep(item.parentReference.driveId) : item.id;
    input.fileId = cloneDeep(item.id);
    input.id = 0;
    input.extension = isDocLibrary ? 'documentLibrary' : item.extension;
    this.dataService.openRenameFileModal.next(input);
  }

  okFileBtnClick(ev: any): void {
    if (ev.toggle) {
      if (ev.obj) {
        this.deleteFile(ev.obj);
      }
    }
    this.delFileItem = undefined;
  }

  deleteFile(item): void {
    // remove file object from array
    let idx = this.driveItems.findIndex(x => x.id === item.id);
    if (idx > -1) {
      this.driveItems.splice(idx, 1);
    }
    this._oneDriveService.deleteMsFile(item.id, item.parentReference ? item.parentReference.driveId : item.id)
      .subscribe((result) => {
        if (!result.isError) {
          let options = this.toastrOptions;
          this.toastr.success('<b>' + item.name + '</b> deleted successfully.<br>', null, options);
        } else {
          if (result.errorMessage === '103') {
            this.information = 'You do not have the necessary permissions to delete files/folders in this location. Please choose a different destination or contact your administrator for access.';
            this.isShowInfoPopup = true;
          }
        }
      });
  }

  showSelectAll() {
    this.isShowSelectAll = !this.isShowSelectAll;
  }

  hideSelectAllBar() {
    this.isShowSelectAll = false;
    this.isAllItemsSelected = false;
    this.assignIsSelectedToDriveItems();
    this.noOfSelectedItems = this.driveItems.filter(x => x.isSelected).length;
  }

  selectAllItems() {
    this.isAllItemsSelected = !this.isAllItemsSelected;
    this.assignIsSelectedToDriveItems();
    this.noOfSelectedItems = this.driveItems.filter(x => x.isSelected).length;
  }

  clearAllSelectedItems() {
    this.isAllItemsSelected = false;
    this.assignIsSelectedToDriveItems();
    this.noOfSelectedItems = this.driveItems.filter(x => x.isSelected).length;
  }

  private assignIsSelectedToDriveItems() {
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        element.isSelected = this.isAllItemsSelected;
      });
    }
  }

  selectItem(item) {
    this.isAllItemsSelected = false;
    item.isSelected = !item.isSelected;
    this.noOfSelectedItems = this.driveItems.filter(x => x.isSelected).length;
  }

  moveWithinThisFolder(item?) {
    if (item) {
      let input = new Array<any>();
      let data = {
        selectedLocation: { name: 'My Files' },
        items: input,
        type: 'moveWithin'
      }
      let obj = {
        id: item.id,
        driveId: item.parentReference.driveId,
        fileId: item.id,
        siteId: item.parentReference.siteId,
        name: item.name,
        extension: item.extension
      };
      input.push(obj);
      this.dataService.openCopyOrMovePopup.next(data);
    } else {
      let selectedItems = this.driveItems.filter(x => x.isSelected);
      if (selectedItems.length > 0) {
        let input = new Array<any>();
        let data = {
          selectedLocation: { name: 'My Files' },
          items: input,
          type: 'moveWithin'
        }
        selectedItems.forEach(element => {
          let obj = {
            id: element.id,
            driveId: element.parentReference.driveId,
            fileId: element.id,
            siteId: element.parentReference.siteId,
            name: element.name,
            extension: element.extension
          };
          input.push(obj);
        });
        this.dataService.openCopyOrMovePopup.next(data);
      } else {
        let options = this.toastrOptions;
        this.toastr
          .error('Please select at least one item to move.',
            null, options);
      }
    }
  }

  moveToDiffLocation(item?) {
    if (item) {
      let input = new Array<any>();
      let data = {
        selectedLocation: null,
        items: input,
        type: 'move'
      }
      let obj = {
        id: item.id,
        driveId: item.parentReference.driveId,
        fileId: item.id,
        siteId: item.parentReference.siteId,
        name: item.name,
        extension: item.extension
      };
      input.push(obj);
      this.dataService.openCopyOrMovePopup.next(data);
    } else {
      let selectedItems = this.driveItems.filter(x => x.isSelected);
      if (selectedItems.length > 0) {
        let input = new Array<any>();
        let data = {
          selectedLocation: null,
          items: input,
          type: 'move'
        }
        selectedItems.forEach(element => {
          let obj = {
            id: element.id,
            driveId: element.parentReference.driveId,
            fileId: element.id,
            siteId: element.parentReference.siteId,
            name: element.name,
            extension: element.extension
          };
          input.push(obj);
        });
        this.dataService.openCopyOrMovePopup.next(data);
      } else {
        let options = this.toastrOptions;
        this.toastr
          .error('Please select at least one item to move.',
            null, options);
      }
    }
  }

  copyWithinThisFolder(item?) {
    if (item) {
      let input = new Array<any>();
      let data = {
        selectedLocation: { name: 'My Files' },
        items: input,
        type: 'copyWithin'
      }
      let obj = {
        id: item.id,
        driveId: item.parentReference.driveId,
        fileId: item.id,
        siteId: item.parentReference.siteId,
        name: item.name,
        extension: item.extension
      };
      input.push(obj);
      this.dataService.openCopyOrMovePopup.next(data);
    } else {
      let selectedItems = this.driveItems.filter(x => x.isSelected);
      if (selectedItems.length > 0) {
        let input = new Array<any>();
        let data = {
          selectedLocation: { name: 'My Files' },
          items: input,
          type: 'copyWithin'
        }
        selectedItems.forEach(element => {
          let obj = {
            id: element.id,
            driveId: element.parentReference.driveId,
            fileId: element.id,
            siteId: element.parentReference.siteId,
            name: element.name,
            extension: element.extension
          };
          input.push(obj);
        });
        this.dataService.openCopyOrMovePopup.next(data);
      } else {
        let options = this.toastrOptions;
        this.toastr
          .error('Please select at least one item to copy.',
            null, options);
      }
    }
  }

  copyToDiffLocation(item?) {
    if (item) {
      let input = new Array<any>();
      let data = {
        selectedLocation: null,
        items: input,
        type: 'copy'
      }
      let obj = {
        id: item.id,
        driveId: item.parentReference.driveId,
        fileId: item.id,
        siteId: item.parentReference.siteId,
        name: item.name,
        extension: item.extension
      };
      input.push(obj);
      this.dataService.openCopyOrMovePopup.next(data);
    } else {
      let selectedItems = this.driveItems.filter(x => x.isSelected);
      if (selectedItems.length > 0) {
        let input = new Array<any>();
        let data = {
          selectedLocation: null,
          items: input,
          type: 'copy'
        }
        selectedItems.forEach(element => {
          let obj = {
            id: element.id,
            driveId: element.parentReference.driveId,
            fileId: element.id,
            siteId: element.parentReference.siteId,
            name: element.name,
            extension: element.extension
          };
          input.push(obj);
        });
        this.dataService.openCopyOrMovePopup.next(data);
      } else {
        let options = this.toastrOptions;
        this.toastr
          .error('Please select at least one item to copy.',
            null, options);
      }
    }
  }

  deleteSelectedItems() {
    let selectedItems = this.driveItems.filter(x => x.isSelected);
    if (selectedItems.length > 0) {
      this.noOfSelectedItems = selectedItems.length;
      this.deleteMultipleFilesDeletePopup.show();
      this.updateBodyForCenterModalShow();
    } else {
      let options = this.toastrOptions;
      this.toastr
        .error('Please select at least one item to delete.',
          null, options);
    }
  }

  closeMultipleFileDeletePopup() {
    this.deleteMultipleFilesDeletePopup.hide();
    this.updateBodyForCenterModalHide();
  }

  deleteMultipleFiles() {
    let selectedItems = this.driveItems.filter(x => x.isSelected);
    if (selectedItems.length > 0) {
      this.isDeleting = true;
      selectedItems.forEach(element => {
        let obj = {
          id: element.id,
          driveId: element.parentReference.driveId,
          fileId: element.id,
          siteId: element.parentReference.siteId,
          name: element.name,
          extension: element.extension
        };
        this._oneDriveService.deleteMsFile(obj.fileId, obj.driveId).subscribe(result => {
          if (!result.isError) {
            let idxItem = selectedItems.findIndex(x => x.id === obj.fileId);
            if (idxItem > -1) {
              selectedItems.splice(idxItem, 1);
            }
            let idxDriveItem = this.driveItems.findIndex(x => x.id === obj.fileId);
            if (idxDriveItem > -1) {
              this.driveItems.splice(idxItem, 1);
            }
            if (selectedItems.length === 0) {
              this.isDeleting = false;
              let options = this.toastrOptions;
              this.toastr.success('Selected items deleted successfully.', null, options);
              this.deleteMultipleFilesDeletePopup.hide();
              this.updateBodyForCenterModalHide();
              this.getMyFiles(false);
              this.hideSelectAllBar();
            }
          } else {
            this.isDeleting = false;
            if (result.errorMessage === '103') {
              this.information = 'You do not have the necessary permissions to delete files/folders in this location. Please choose a different destination or contact your administrator for access.';
              this.isShowInfoPopup = true;
            } else {
              let options = this.toastrOptions;
              this.toastr
                .error('Error while deleting selected items.',
                  null, options);
              this.getMyFiles(false);
            }
          }
        });
      });
    }
  }

  addM365FileTaskToMyDay(item, isDocLibrary, sectionId) {
    let input = new CreateFileTask();
    input.code = 111;
    input.entity = 0;
    input.entityId = 0;
    input.id = 0;
    input.keyId = item.id;
    input.filePath = item.webUrl;
    input.fileName = item.name;
    input.fileType = item.extension;
    input.webLink = item.webUrl;
    input.isLink = false;
    input.isShareFile = false;
    input.isAddToShortcut = false;
    input.msDriveId = item.parentReference ? item.parentReference.driveId : item.id;
    input.msSiteId = item.parentReference ? item.parentReference.siteId : null;
    input.msFolderId = item.folderId ? item.folderId : '';
    input.startDate = null;
    input.userSectionId = sectionId ? sectionId : 0;
    this.dataService.addFileTaskToAgenda.next(input);
  }

  addM365FileTaskToDoLater(item, isDocLibrary) {
    let input = new CreateFileTask();
    input.code = 121;
    input.entity = 0;
    input.entityId = 0;
    input.id = 0;
    input.keyId = item.id;
    input.filePath = item.webUrl;
    input.fileName = item.name;
    input.fileType = item.extension;
    input.webLink = item.webUrl;
    input.isLink = false;
    input.isShareFile = false;
    input.isAddToShortcut = false;
    input.msDriveId = item.parentReference ? item.parentReference.driveId : item.id;
    input.msSiteId = item.parentReference ? item.parentReference.siteId : null;
    input.msFolderId = item.folderId ? item.folderId : '';
    input.startDate = null;
    this.dataService.openDoLaterModal.next(input);
  }

  showAddItem(type) {
    this.isShowAddItem = true;
    this.selectedDocType = type;
    setTimeout(() => {
      if (this.selectedDocType !== 5) {
        $('.create-file').trigger('focus');
      } else if (this.selectedDocType === 5) {
        $('.create-folder').trigger('focus');
      }
    }, 750);
  }

  onNewFileKeyPress(event: any, isOneDrive, level): boolean {
    if (event.keyCode === 13) {
      this.createFile(event, isOneDrive, level);
    }
    return event.keyCode !== 13;
  }

  onNewFileBlur(event: any, isOneDrive, level) {
    let value: string = event.target.innerText.trim();
    if (value.length > 0) {
      this.createFile(event, isOneDrive, level);
    }
    this.isShowAddItem = false;
  }


  onNewFolderKeyPress(event: any, isOneDrive, level): boolean {
    if (event.keyCode === 13) {
      this.createFolder(event, isOneDrive, level);
    }
    return event.keyCode !== 13;
  }

  onNewFolderBlur(event: any, isOneDrive, level) {
    let value: string = event.target.innerText.trim();
    if (value.length > 0) {
      this.createFolder(event, isOneDrive, level);
    }
    this.isShowAddItem = false;
  }

  createFile(event, isOneDrive, level): void {
    let value: string = event.target.innerText.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFileInputDto = new CreateFileInputDto();
    input.isShareFile = true;
    input.isOneNote = this.selectedDocType === 4 ? true : false;
    input.name = value.trim();
    if (this.selectedDocType === 1) {
      input.extension = '.docx';
    } else if (this.selectedDocType === 2) {
      input.extension = '.xlsx';
    } else if (this.selectedDocType === 3) {
      input.extension = '.pptx';
    }
    input.itemId = '';
    input.driveId = '';
    this.isSaving = true;
    event.target.innerText = '';
    if (input.itemId === input.driveId) { input.itemId = undefined; }
    this._oneDriveService.createOneDriveFile(input).subscribe(result => {
      this.isSaving = false;
      event.target.innerText = '';
      if (!result.isError) {
        this.getMyFiles(false);
      } else {
        if (result.errorMessage === '103') {
          this.information = 'You do not have the necessary permissions to upload or create files/folders in this location. Please choose a different destination or contact your administrator for access.';
          this.isShowInfoPopup = true;
        }
        // if (result.errorMessage.includes('20117')) {
        //   this.fileNameError = true;
        //   this.fileNameErrorMessage = 'An item with this name already exists in this location.';
        // }
      }
    });
  }

  okInfoPopupClicked(ev: any) {
    this.isShowInfoPopup = false;
  }

  createFolder(event, isOneDrive, level): void {
    let value: string = event.target.innerText.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFolderDto = new CreateFolderDto();
    input.isDocLibrary = false;
    input.isRename = false;
    input.name = value.trim();
    input.itemId = '';
    input.driveId = '';
    input.folderType = 1;
    this.isSaving = true;
    event.target.innerText = '';
    this._oneDriveService.createFolder(input).subscribe(result => {
      this.isSaving = false;
      event.target.innerText = '';
      if (!result.isError) {
        this.getMyFiles(false);
      } else {
        if (result.errorMessage === '103') {
          this.information = 'You do not have the necessary permissions to upload or create files/folders in this location. Please choose a different destination or contact your administrator for access.';
          this.isShowInfoPopup = true;
        }
        // if (result.errorMessage.includes('20117')) {
        //   this.fileNameError = true;
        //   this.fileNameErrorMessage = 'An item with this name already exists in this location.';
        // }
      }
    });
  }

  fileInputChanged(event, isOneDrive, level): void {
    let that = this;
    if (event.target.value) {
      if (event.target.files) {
        // Reset between invocations so a previously-rejected file doesn't
        // poison subsequent valid uploads.
        that.fileUploadError = false;
        that.fileErrorMsg = '';
        let files = [];
        files = event.target.files;
        if (event.target.files.length > 0) {
          for (let index = 0; index < event.target.files.length; index++) {
            const element = event.target.files[index];
            if (element.size >= AppConsts.uploadFileSize) {
              that.toastr.error(`"${element.name}" is too large to upload. Maximum size is 25 MB.`, null, that.toastrOptions);
              that.fileUploadError = true;
              that.fileErrorMsg = 'Cannot upload file above 25mb.';
            } else if (element.size === 0) {
              that.toastr.error(`"${element.name}" is empty and can't be uploaded.`, null, that.toastrOptions);
              that.fileUploadError = true;
              that.fileErrorMsg = 'Cannot upload file with 0kb.';
            }
          }
          that.fileRawData = [];
          if (!that.fileUploadError) {
            let fileCts = event.target.files.length;
            for (let index = 0; index < event.target.files.length; index++) {
              const element = event.target.files[index];
              that.fileUploadError = false;
              let file = element;
              that.fileRawData.push(file);
              fileCts--;
              if (fileCts <= 0) {
                that.isUploadFiles = true;
                that.uploadFileToSpecificFolder(isOneDrive, level);
                event.target.value = null;
              }
            }
          } else {
            that.fileUploadError = false;
          }
        }
      }
    }
  }

  uploadFileToSpecificFolder(isOneDrive, level) {
    if (this.fileRawData.length > 0) {
      let fileCts = this.fileRawData.length;
      let options = this.toastrOptions;
      this.toastr
        .success('We are uploading file(s). Please wait for a while.',
          null, options);
      let that = this;
      this.fileRawData.forEach((element, index) => {
        let itemId = '';
        let driveId = '';
        if (driveId === itemId) {
          itemId = undefined;
        }
        that.isSaving = true;
        that._oneDriveService.uploadFile({ data: element, fileName: element.name } as FileParameter, driveId, itemId, 0).subscribe(result => {
          if (!result.isError) {
            fileCts--;
            if (fileCts <= 0) {
              this.isSaving = false;
              let options = that.toastrOptions;
              that.toastr
                .success('File(s) uploaded successfully.',
                  null, options);
              this.getMyFiles(false);
            }
          } else {
            this.isSaving = false;
            if (result.errorMessage === '103') {
              this.information = 'You do not have the necessary permissions to upload or create files/folders in this location. Please choose a different destination or contact your administrator for access.';
              this.isShowInfoPopup = true;
            } else {
              that.fileUploadError = true;
              that.fileErrorMsg = 'Something went wrong while uploading file.';
            }
          }
        });
      });
    }
  }

  private getSharepointSites() {
    this.isSharePointSitesLoading = true;
    this._oneDriveService.getSharePointSites('').subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData.length > 0) {
          this.sharePointSitesData = result.responseData;
          this.sharePointSitesData.forEach(element => {
            element.isShow = true;
            element.isSelected = false;
          });
        }
      }
    });
  }

  applySearchOnLevel1() {
    if (this.sharePointSitesData.length > 0) {
      this.sharePointSitesData.forEach(element => {
        if (element.displayName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) {
          element.isShow = true;
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel1();
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel1() {
    let noOfIsShowItems = this.sharePointSitesData.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel1() {
    this.searchText = '';
    if (this.sharePointSitesData.length > 0) {
      this.sharePointSitesData.forEach(element => {
        element.isShow = true;
      });
      this.checkIfItemsToShowOnLevel1();
    } else {
      this.noResultFound = false;
    }
  }

  changeTab(tab): void {
    if (tab === 1) {
      this.currentTab = 1;
      this.removeSearch();
      this.getTeamDriveData(true);
      this.initializeScroll();
    } else if (tab === 2) {
      this.currentTab = 2;
      this.removeSearch();
      this.getMyFiles(true);
      this.hideSelectAllBar();
    } else if (tab === 3) {
      this.currentTab = 3;
      this.removeSearch();
      this.getSharePoint();
    } else if (tab === 4) {
      this.currentTab = tab;
      this.removeSearch();
      this.selectRecentFileTab();
    }
  }

  getUserSections() {
    // this._agendaService.getUserSections().subscribe(result => {
    //   if (!result.isError) {
    //     this.userSectionData = result.responseData;
    //   }
    // });
  }

  closeNestedDropdown(): void {
    if (this.nestedDropdown && this.nestedDropdown.isOpen) {
      this.nestedDropdown.hide();
    }
  }

  closeCopyDropdown(): void {
    if (this.copyDropdown && this.copyDropdown.isOpen) {
      this.copyDropdown.hide();
    }
  }

  closeMoveDropdown(): void {
    if (this.moveDropdown && this.moveDropdown.isOpen) {
      this.moveDropdown.hide();
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.dataService.isAccountLinked.observers = [];
    this.dataService.refreshFilesSlider.observers = [];
    this.dataService.closeFileList.observers = [];
    this.dataService.refreshGroups.observers = [];
    this.dragulaService.destroy('fileDragula');
    // this.dragulaService.destroy('shortcutDragula');
    this.dragulaService.destroy('teamDriveCatDragula');
    this.dragulaService.destroy('teamDriveLinkDragula');
    if (this.scrollElemnts) {
      this.scrollElemnts.destroy();
      this.scrollElemnts = undefined;
    }
  }
}
